<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-sm-12">
        <form class="plansform">
          <div class="row mt-3">
            <div class="row">
              <div class="col-12 mb-2">
                <h6 class="admintitle" style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background-color: #142A49;
                  
                  ">
                  <div>
                    <!-- {{lang.Overview}}&nbsp;&nbsp;{{
                      registeredDate=='NA'?'(Setup not complete)'
                      :registeredDate!=undefined && registeredDate!=null?'(Setup completed)':''}} -->
                    {{lang.Overview}}&nbsp;&nbsp;{{
                      registeredDate=='NA'?'(Draft)'
                      :''}}
                  </div>
                  <button (click)="editCorporate()" on style="
                      background-color: white;
                      border: 0px;
                      color:#142A49;
                      padding: 5px;
                      border-radius: 5px;
                    ">
                   {{lang.Edit}}
                  </button>
                </h6>
              </div>

              <div class="tilesContainer row">
                <!-- {{lang.Corporate_Information}} -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Corporate_Information}}</span>
                      <button data-bs-toggle="modal" data-bs-target="#updateCorpInfo2" class="addgroupadmininfoemp"
                        *ngIf="!formConfigLoading">
                        <strong>
                          <!-- <i class="bi bi-pencil-square" style="
                              color: #ffffff;
                              cursor: pointer;
                              margin-right: 5px;
                            " title="Edit"></i> -->
                            {{lang.Edit}}</strong>
                      </button>
                      <div class="is-loading col-3" *ngIf="formConfigLoading">
                        <p></p>
                      </div>
                    </div>
                    <div class="_card_body _card_body_bottom corp_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/Corporate_Info.png" />
                      </div>
                      <div class="_card_body_body">
                        <div class="mt-2">
                          <div class="ms-2">
                            <span>
                              <a class="spanCopy ftsize12" href="{{ loginLink }}"
                               target="_blank" ><span>
                                <!-- {{lang.Corporate_Portal}} -->
                                 Plan Administrator Portal
                                </span></a>
                            </span>

                            <span>
                              <button id="copyButton1" style="border: none"
                                class="spanCopy1 btnSizes mt-1 ms-1 mb-2 ftsize12 cursor-pointer"
                                (click)="copyToClipboard1()" title="Copy">
                                <a href style="
                                    pointer-events: none;
                                    font-family: sans-serif;
                                    text-decoration: none !important;
                                  ">
                                  <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                              </button>
                            </span>

                            <div *ngIf="currentLogo" class="mt-2">
                              <img src="{{ currentLogo }}" style="
                                  height: auto;
                                  max-height: 65px;
                                  width: auto;
                                  max-width: 100%;
                                " />
                            </div>
                            <div class="mt-2">
                              <img src="./../assets/img/planholder.svg" alt class="widHigSvgIcon"
                                data-bs-toggle="tooltip" data-bs-placement="top" title="Name" /><span class="ms-2">{{
                                CorpName }}</span>
                            </div>
                            <div class="mt-2">
                              <img src="./../assets/img/policy_date.png" alt class="widHigSvgIcon"
                                data-bs-toggle="tooltip" data-bs-placement="top" title="Policy Start Date" />
                              <span class="ms-2">{{ policyStartDate }}</span>
                            </div>
                            <div class="mt-2 d-flex">
                              <span class>
                                <img src="./../assets/img/location.svg" alt class="widHigSvgIcon"
                                  data-bs-toggle="tooltip" data-bs-placement="top" title="Address" />
                              </span>
                              <span class="ms-1">
                                <div>
                                  {{ streetAddress }}
                                </div>
                                <div>{{ streetAddress2 }} {{ apt }}</div>
                                <div>
                                  {{ city }} {{ province }} {{ postalCode }}
                                </div>
                              </span>
                            </div>
                            <div class="mt-2 mb-5">
                              <img src="./../assets/img/MultiProvince.png" alt class="widHigSvgIcon"
                                data-bs-toggle="tooltip" data-bs-placement="top"
                                title="Provincial offices in Operation" />
                              <span class="ms-2">
                                {{
                                multiProvinceSelectedValues
                                }}
                              </span>
                            </div>
                            <div class="mt-2 mb-5">
                              <i class="fa fa-info-circle" id="tooltip" style="cursor: pointer;" title="IGBMS ID">
                                 <!-- IGBMS ID:{{fusebillCustomerId}}</i> -->
                                 {{igbmsId}}</i>
                                <table class="tooltiptext ignoreTable">
                                  <tbody>
                                    <tr class="ignoreTable">
                                      <td>Corporate ID:{{corpDetails?.corporateId}}</td>
                                      <td>Parent ID:{{corpDetails?.parentId}}</td>

                                    </tr>

                                  </tbody>
                                </table>

                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                      </div> -->
                    </div>
                  </div>
                </div>

                <!-- Group benefits invoices -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Invoices}}</span>
                      <div class="dropdown">
                        <!-- Custom dropdown toggle -->
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-bs-toggle="dropdown" aria-expanded="false">
                          {{ filterInvoice === 'Custom' ? 'Custom' : filterInvoice || 'Select Year' }}
                        </button>
        
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li><a class="dropdown-item" (click)="filterInvoice = 'All'; filterInvoices()">All</a></li>
                          <li><a class="dropdown-item"
                              (click)="filterInvoice = currentYear-1; filterInvoices()">{{currentYear-1}}</a></li>
                          <li><a class="dropdown-item"
                              (click)="filterInvoice = currentYear; filterInvoices()">{{currentYear}}</a></li>
                          <li><a class="dropdown-item"
                              (click)="filterInvoice = currentYear+1; filterInvoices()">{{currentYear+1}}</a></li>
                          <li><a class="dropdown-item" (click)="onCustomClick($event)">Custom</a></li>
        
                          <!-- Custom date input -->
                          <li class="dropdown-item">
                            <div *ngIf="filterInvoice === 'Custom'">
                              <input type="text" id="filterDateSelection" [(ngModel)]="filterDateSelection" class="form-control"
                                placeholder="Select Month" bsDaterangepicker
                                [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month', showWeekNumbers: false }"
                                [maxDate]="maxDateForPicker" (ngModelChange)="CustomInvoiceFilter()" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="_card_body _card_body_bottom invoice_card ftsize8 position-relative">
                      <div class="_card_body_image">
                        <!-- <span class="imagetext2">
                          <p>Configuration &nbsp;
                            <i class="bi bi-pencil-square"
                              data-bs-toggle="modal"
                              data-bs-target="#editEmailConfiguration"
                              (click)="getConfigurationEmails()"
                              style="color:#1429A9; cursor: pointer;"
                              title="Edit"></i>
                          </p>
                          <p>Send emails to (default email address)</p>
                        </span> -->
                        <img src="./../assets/img/invoices.png" />
                      </div>
                      <div class="_card_body_body p-2" *ngIf="
                          customerFinalInvoices && customerFinalInvoices.length > 0; else noInvoices">

                        <!-- <ng-container>
                          <div class="col-md-6 text-nowrap d-flex ps-0" [class.ml-2]="invoicesArr.length > 1">
                            <div class="col-7 text-nowrap ps-0 pe-0">
                              {{ nextMonthName }} {{ year }}
                              (Draft)
                            </div>
                            <div class="col-2 text-nowrap d-flex ps-0" style="margin-top: 2px; margin-left: 7px">
                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                style="cursor: pointer" id="viewing" role="button" title="View"
                                (click)="showDraftInvoice()" />&nbsp;&nbsp;
                              <img src="/assets/img/download2.png" class="viewDownloadIcon cursor-pointer"
                                style="cursor: pointer; display: none" id="viewing" role="button"
                                data-bs-toggle="tooltip" dat a-bs-placement="top" title="Download" />
                            </div>
                          </div>
                        </ng-container> -->

                        <!-- <div *ngIf="invoicesArr.length == 0" (click)="getInvoices()" class="showallinvoices" style="
                            cursor: pointer;
                            text-decoration: underline;
                            color: #384c97;
                          ">
                          {{lang.Show_all_invoices}}
                        </div> -->

                        <div class="invoice-container">
                          <div class="invoice-item" *ngFor="let invoice of customerFinalInvoices; let i = index"
                            >
                            <!-- <div class="col-7 text-nowrap pe-0 ps-0 d-flex align-items-end">
                              <span>{{invoice.dueDate | date : "MMM yyyy"}}</span>
                            </div>
                            <div class="col-2 text-nowrap ps-0">
                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer" id="viewing"
                                role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="View"
                                (click)="showInvoice(invoice, i)" />&nbsp;
                              <img src="/assets/img/download2.png" class="viewDownloadIcon cursor-pointer" id="viewing"
                                role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                (click)="downloadInvoice(invoice, i)" />
                            </div> -->
                            <div class="d-flex justify-content-between w-100">

                              <div 
                                [ngStyle]="{
                                  color: invoice.status == 'PAID' ? 'green' : 
                                  (invoice.status == 'OVERDUE' ? 'red' : 
                                  (invoice.status == 'POST' ? 'orange' : 
                                  (invoice.status == 'VOID' ? 'rgb(93, 124, 155)':
                                  (invoice.status == 'DRAFT' ? '#07a3d4' : 'black'))) )}"
                                  style = "font-size:14px;">
                                {{
                                invoice.dueDate | date : "MMM yyyy"
                                }} ({{ invoice.status | titlecase }})
                              </div>
                            <div>
                              <img role="button" src="/assets/img/view.png" alt="" width="14px" height="14px" id="viewing"
                                role="button" data-bs-toggle="modal" data-bs-target="#viewinvoice" data-bs-placement="top"
                                title="View" (click)="showInvoice(invoice)" />&nbsp;&nbsp;
  
                              <img role="button" src="/assets/img/download.png" alt="" width="14px" height="14px" id="viewing"
                                role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                title="Download" (click)="downloadInvoice(invoice, i)" />
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                      <ng-template #noInvoices>
                        <p class="text-muted ftsize12" style="text-align: center;padding: 20px;
                          font-family: sans-serif;  color:black !important;
                          font-style: bold;"> {{lang?.No_Invoices_Available}}</p>
                      </ng-template>
                      <!-- Footer -->
                      <div class="row mx-0 invoice-footer px-2">
                        <!-- Top row: 3 columns -->
                        <!-- <div class="col-4 d-flex align-items-center">
                          <div class="draft-invoice me-1"></div>
                          <div style="font-size: 9px;">Draft</div>
                        </div> -->
                        <!-- <div class="col-4 d-flex align-items-center">
                          <div class="paid-invoice me-1"></div>
                          <div style="font-size: 9px;">Paid</div>
                        </div> -->
                        <!-- <div class="col-4 d-flex align-items-center">
                          <div class="post-invoice me-1"></div>
                          <div style="font-size: 9px;">Post</div>
                        </div>
                       -->
                        <!-- Bottom row: 2 centered columns -->
                        <!-- <div class="col-4 d-flex align-items-center">
                          <div class="void-invoice me-1"></div>
                          <div style="font-size: 9px;">Void</div>
                        </div> -->
                        <!-- <div class="col-4 d-flex align-items-center" style="padding:0px;">
                          <div class="overdue-invoice me-1"></div>
                          <div style="font-size: 9px;">Overdue</div>
                        </div> -->
                      </div>
                      
                      
                      
                    </div>
                  </div>
                </div>
                <!-- Group Benefits Plan Features -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="setUplevelofCoverage!=true">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Plans}}</span>
                      <button class="addgroupadmininfoemp" (click)="corpPlansNavigate()" *ngIf="!formConfigLoading" data-bs-toggle="modal" data-bs-target="#basicModaledit">
                        <strong>
                          <!-- <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#basicModaledit"
                            style="
                              color: #ffffff;
                              cursor: pointer;
                              margin-right: 5px;
                            " title="Edit"></i> -->
                            {{lang.Edit}}
                        </strong>
                      </button>
                      <div class="is-loading col-3" *ngIf="formConfigLoading">
                        <p></p>
                      </div>
                    </div>
                    <div class="_card_body plans_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/Plans.png" />
                      </div>
                      <div class="_card_body_body pt-2">
                        <div  style="margin-left: 10px" class="col-12 ftsize12">

                          <table *ngIf="corpDetails?.setUplevelofCoverage; else generateInviteLink">
                            <tr *ngFor="let item of genericTierLinks" style="border:1px solid black">
                              <td class="ftsize10" style="font-size:10px;">{{item.name}}</td>
                              <td>
                                  <span style="font-size:10px;">
                                    <a class="spanCopy ftsize10" [href]="item.link"><span style="font-size:10px;">
                                      <!-- {{lang.Sign_up_Link}} -->
                                      Enrollment Link
                                      </span></a>
                                  </span>
                                  <span style="font-size:10px;">
                                    <button id="copyButton" style="border: none" class="spanCopy1 btnSizes mt-1 ms-1 mb-2 ftsize12 cursor-pointer"
                                      (click)="copyToClipboard(item.link)" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy">
                                      <a href style="
                                                                    pointer-events: none;
                                                                    font-family: sans-serif;
                                                                    text-decoration: none !important;
                                                                  ">
                                        <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                                    </button>
                                  </span>
                              </td>
                            </tr>
                          </table>
                          <ng-template #generateInviteLink>
<span class="spanCopy ftsize12" style="border: none">
  <span>
    <a class="spanCopy ftsize12" href="{{ corpDetails?.defaultTier?.signupLink }}"><span>
      <!-- {{lang.Sign_up_Link}} -->
      Enrollment Link
      </span></a>
  </span>
  <span>
    <button id="copyButton" style="border: none" class="spanCopy1 btnSizes mt-1 ms-1 mb-2 ftsize12 cursor-pointer"
      (click)="copyToClipboard(corpDetails?.defaultTier?.signupLink)" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy">
      <a href style="
                                    pointer-events: none;
                                    font-family: sans-serif;
                                    text-decoration: none !important;
                                  ">
        <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
    </button>
  </span>
</span>
                          </ng-template>




                        </div>

                        <div class="row ms-0 ftsize12">
                          <div>
                            {{lang.Plans}}:
                          </div>

                          <div class="row ftsize12 d-flex" *ngFor="let bplans of bulkPlans">
                            <span class="ftsize12">{{ bplans.planLevel }}
                              {{lang.Group}} - {{ bplans?.status}}
                            </span>
                            <div class="d-flex">
                              <span class="mb-2">
                                <span class="ftsize11 text-nowrap">
                                  <!-- {{lang?.Employee_Count}}: {{ showEmployeeValue}} -->
                                  {{lang?.Employee_Count}}: {{ bplans?.quantity ?? showEmployeeValue}}
                                </span>
                                <br>
                                <!-- <span class="ftsize11 text-nowrap">
                                  {{lang?.Status}}: {{ bplans?.status}}
                                </span>
                                <br> -->
                                <span class="ftsize11 text-nowrap" *ngIf="bplans?.backdatedActivationDate || bplans?.activationDate">
                                  {{lang?.Plan_Start_Date ?? 'Plan Start Date'}}: {{ 
                                    (bplans?.backdatedActivationDate ?? bplans?.activationDate) |date
                                  }}
                                </span>
                                <br>
                                <span class="ftsize11 text-nowrap" 
                                  *ngIf="bplans?.backdatedCancellationDate || bplans?.cancellationDate || bplans?.terminationDate">
                                  {{lang?.Plan_End_Date??'Plan End Date'}}: {{ 
                                    (bplans?.backdatedCancellationDate ?? bplans?.cancellationDate ?? bplans?.terminationDate) | date
                                  }}
                                <span class="ftsize8" *ngIf="bplans?.terminationDate && bplans?.terminationReason">
                                  | {{bplans?.terminationReason}}
                                </span>
                              </span>
                                  
                              </span>
                            </div>
                          </div>
                        
<div class="row ftsize12" *ngFor="let plan of allUniquePlansByType" style-="margin-bottom: 10px">
  <span>
    {{ plan.planLevelName }}
    <span *ngIf="renewalDate[plan.planLevelName] && renewalDate[plan.planLevelName] !== 'NA'" style="font-size: 10px;">
      (Renews on {{ renewalDate[plan.planLevelName] }})
    </span>
  </span>
</div>
    

                          <!-- <span *ngIf="paidByCompany?.length > 0">
                            <div class="row" *ngFor="let plans of paidByCompany" style="margin-bottom: 10px">
                              <span class="ftsize12">{{ plans.planLevelName }}
                                <span style="font-size: 10px">
                                  (Renews on
                                  {{
                                  renewalDate[plans.planLevelName]
                                  ? renewalDate[plans.planLevelName]
                                  : "NA"
                                  }})
                                </span>
                              </span>
                            </div>
                          </span> -->

                          <!-- <span *ngIf="coveredByCompany?.length > 0">
                            <div class="row ftsize12" *ngFor="let plans of coveredByCompany"
                              style="margin-bottom: 10px">
                              <span class>{{ plans.planLevelName }}
                                <span style="font-size: 10px">
                                  (Renews on
                                  {{
                                  renewalDate[plans.planLevelName]
                                  ? renewalDate[plans.planLevelName]
                                  : "NA"
                                  }})
                                </span>
                              </span>
                            </div>
                          </span> -->

                          <!-- <span *ngIf="paidByEmployee?.length > 0">
                            <div class="row ftsize12" *ngFor="let plans of paidByEmployee" style="margin-bottom: 10px">
                              <span class>{{ plans.planLevelName }}
                                <span style="font-size: 10px">
                                  (Renews on
                                  {{
                                  renewalDate[plans.planLevelName]
                                  ? renewalDate[plans.planLevelName]
                                  : "NA"
                                  }})
                                </span>
                              </span>
                            </div>
                          </span> -->
                        </div>
                      </div>
                      <div class="_card_body_footer">
                        <div>
                          <p class="ftsize8" style="font-weight: bold; margin-top: 15px">
                            {{lang.Note}}:
                          </p>
                          <p class="ftsize8" style="margin-top: -15px">
                            {{lang.Premiums_may_change_on_the_renewal_date_Please_contact_your_Broker_Advisor_for_more_information}}.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="tierPlans?.length == 1 && setUplevelofCoverage==true">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Plans}}

                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="_card_body">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/Plans.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-2 _card_body_body tileMarginDown" *ngFor="
                          let tier of tierPlans;
                          let i = index
                        ">
                          <div class="d-flex flex-column">
                            <b>Plan:</b>
                            <span>{{tier.planLevelName}}</span>
                            <span>Available in tier(s): {{tier.tier}}</span>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Corporate Plans -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    (tierPlans?.length > 1 ||
                    tierPlans?.length == 0) && setUplevelofCoverage==true
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Plans}}
                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="mt-2">
                        <div>
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let tier of tierPlans;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/Plans.png" style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                      " />
                                    </div>
                                    <div style="padding-left: 10px" class="card-body tileMarginDown py-2 tileheight">
                                      <div class="py-2 px-2 _card_body_body tileMarginDown">
                                        
                                        <div class="d-flex flex-column">
                                          <b>Plan:</b>
                                          <span>{{tier.planLevelName}}</span>
                                          <span>Available in tier(s): {{tier.tier}}</span>
                                        </div>

                                      </div>
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="tierPlans.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- corporate tier plans -->

                <!-- <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Corporate_Tier_Plans}}</span>
                    </div>
                    <div class="_card_body invoice_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/invoices.png" />
                      </div>
                      <div class="_card_body_body tileMarginDown p-2">
                        <div class="accordion accordion-flush" id="accordionFlushExample">
                          <div *ngFor="
                              let plan of corporateTierPlans;
                              let i = index
                            ">
                            <div *ngIf="plan.name != 'ALL'" class="plan-name">
                              {{ plan.name }}
                            </div>

                            <div *ngIf="plan.planLevels.length == 0">
                              {{lang.No_Tier_Plans_to_show}}
                            </div>

                            <div *ngIf="plan.planLevels.length > 0" style="
                                width: 100%;
                                display: flex;
                                justify-content: space-between;
                                border-bottom: 1px solid
                                  rgba(124, 124, 124, 0.884);
                              ">
                              <i>{{lang.Plan_Level}}</i>
                              <i>{{lang.Plan_Type}}</i>
                            </div>

                            <div *ngFor="let planLevel of plan.planLevels">
                              <div style="
                                  display: flex;
                                  justify-content: space-between;
                                  align-items: center;
                                  margin-bottom: 10px;
                                ">
                                <div style="width: 50%">
                                  {{ planLevel.planLevelName }}
                                </div>
                                <div style="width: 50%; text-align: right">
                                  {{
                                  planLevel.coveredByCompany
                                  ? "Covered By Company"
                                  : planLevel.paidByCompany
                                  ? "Paid By Company"
                                  : "Paid By Employee"
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="corporateTierPlans?.length==0" class="text-center">{{lang.No_Data_Available}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->


                              <!-- Employees -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"
                  *ngIf="employeeList.length > 1 || employeeList.length === 0">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Employees}}

                        <select (change)="employeeStatus($event)">
                          <option value="All" selected>All</option>
                          <option value="Active">Active</option>
                          <option value="Draft">Draft</option>
                          <option value="Suspended">Suspended</option>
                          <option value="Hold">Hold</option>
                          <option value="Cancelled">Cancelled</option>
                          <option value="Incomplete">Incomplete</option>

                        </select>
                        <button class="addgroupadmininfoemp" (click)="basicEmployeeOpen()" *ngIf="!formConfigLoading">
                          <strong>
                            <!-- <i class="bi bi-pencil-square" style="color:#ffffff; cursor: pointer;" title="Edit">
                            </i> -->
                            {{lang.Edit}}

                          </strong>
                        </button>
                        <div class="is-loading col-3" *ngIf="formConfigLoading" >
                          <p></p>
                        </div>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="employeeList.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let employee of employeeList;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/enrollment_summary.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body tileMarginDown py-2 px-2 groupContactsBgClr tileheight">
                                      <table border="0" class="table border-0 bg-transparent">
                                        <tbody class="d-inline">

                                          <tr>
                                            <td>{{lang.Name}}</td>
                                            <td>
                                              {{
                                              employee.firstName +
                                              " " +
                                              employee.lastName
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <!-- <td>{{lang.Email}}</td>
                                            <td *ngIf="showMaskedMail" style="cursor: pointer"
                                              (click)="toggleAdminEmailClick(employee)">
                                              <span *ngIf="employee.emailClicked">{{
                                                employee.email
                                                }}</span>
                                              <span *ngIf="!employee.emailClicked">{{
                                                employee.maskedEmail ?? employee.email
                                                }}</span>
                                            </td> -->

                                            <td>{{lang.Email}}</td>
   <!-- <td>{{ lang.Email }}</td> -->
  <td>
    <a
      href="javascript:void(0)"
      (click)="copyToClipboard2(employee.email)"
      style="text-decoration: underline; color: blue; cursor: pointer; font-size: 12px;"
      title="Click to copy">
      {{ employee.email }}
    </a>
  </td>
                                            <!-- <td>{{ lang.Email }}</td> -->





                                            <!-- <td [title]="employee.email">

                                              {{
                                              employee.email.length > 12
                                              ? employee.email.slice(
                                              0,
                                              12
                                              ) + "..."
                                              : employee.email
                                              }}
                                            </td> -->
                                          </tr>

                                          <tr>
                                            <td>{{lang.Gender}}</td>
                                            <td>{{ employee.gender }}</td>
                                          </tr>
                                          <tr>
                                            <td>
                                              {{lang.Status}}
                                            </td>
                                            <td>
                                              {{ employee.status }}
                                              <span *ngIf="employee.terminationDate!=''">Terminate Date:{{
                                                employee.terminationDate | date}}</span><br>
                                              <span *ngIf="employee.terminationDate!=''">Terminate Reason:{{
                                                employee.terminationReason }}</span>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>{{lang.Job_Title}}</td>
                                            <td>{{ employee.jobTitle }}</td>
                                          </tr>
                                          <tr>
                                            <td>{{lang.Emp_Id}}</td>
                                            <td>{{ employee.employeeId }}</td>
                                          </tr>
                                          <tr>
                                            <td>{{lang.Date_of_hire}}</td>
                                            <td>{{ employee.dateOfHire }}</td>
                                          </tr>
                                          <tr>
                                            <td>{{lang.Province_Name}}</td>
                                            <td>{{ employee.provinceName }}</td>
                                          </tr>
                                          <!-- <tr>
                                            <td>{{lang.Country}}</td>
                                            <td>{{ employee.country }}</td>
                                          </tr> -->


                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" (click)="leftClick()" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" (click)="rightClick()" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="employeeList.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Employees -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="employeeList.length == 1">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      {{lang.Employees}}

                      <select (change)="employeeStatus($event)">
                        <option value="All">All</option>
                        <option value="Active">Active</option>
                        <option value="Draft">Draft</option>
                        <option value="Suspended">Suspended</option>
                        <option value="Hold">Hold</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Incomplete">Incomplete</option>

                      </select>
                      <!-- <button class="addgroupadmininfoemp" (click)="basicEmployeeOpen()" *ngIf="!formConfigLoading">
                        
                        <strong>
                          <i class="bi bi-pencil-square" style="color:#ffffff; cursor: pointer;" title="Edit">
                          </i>

                        </strong>
                      </button> -->

                       <button  class="addgroupadmininfoemp" (click)="basicEmployeeOpen()" 
                        *ngIf="!formConfigLoading">
                        <strong>
                          <!-- <i class="bi bi-pencil-square" style="
                              color: #ffffff;
                              cursor: pointer;
                              margin-right: 5px;
                            " title="Edit"></i> -->
                            {{lang.Edit}}</strong>
                      </button>
                      
                      <div class="is-loading col-3" *ngIf="formConfigLoading">
                        <p></p>
                      </div>
                      <!-- <button class="addgroupadmininfoemp" (click)="basicEmployeeOpen()">
                        <strong>
                          <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#basicModaledit"
                            style="color: #ffffff; cursor: pointer" title="Edit"></i>
                          &nbsp; {{lang.Edit}}</strong>
                      </button> -->
                    </div>

                    <div class="_card_body">
                      <div class="_card_body_image">
                        <img src="/assets/img/invoices.png" />
                      </div>
                      <div class="_card_body_body tileMarginDown py-2 px-1"
                        *ngFor="let employee of employeeList; let i = index">
                        <table border="0" class="table border-0 bg-transparent">
                          <tbody class="d-inline">

                            <tr>
                              <td>{{lang.Name}}</td>
                              <td>
                                {{
                                employee.firstName + " " + employee.lastName
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{lang.Email}}</td>
                              <!-- <td *ngIf="showMaskedMail" style="cursor: pointer"
                                (click)="toggleAdminEmailClick(employee)">
                                <span *ngIf="employee.emailClicked">{{
                                  employee.email
                                  }}</span>
                                <span *ngIf="!employee.emailClicked">{{
                                  employee.maskedEmail ?? employee.email
                                  }}</span>
                              </td> -->
                              <td>
    <a
      href="javascript:void(0)"
      (click)="copyToClipboard2(employee.email)"
      style="text-decoration: underline; color: blue; cursor: pointer; font-size: 12px;"
      title="Click to copy">
      {{ employee.email }}
    </a>
  </td>
                              <!-- <td>

                                {{
                                employee.email.length > 24
                                ? employee.email.slice(0, 24) + "..."
                                : employee.email
                                }}
                              </td> -->
                            </tr>

                            <tr>
                              <td>{{lang.Gender}}</td>
                              <td>{{ employee.gender }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Status}}</td>
                              <td>{{ employee.status }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Job_Title}}</td>
                              <td>{{ employee.jobTitle }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Emp_Id}}</td>
                              <td>{{ employee.employeeId }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Date_of_hire}}</td>
                              <td>{{ employee.dateOfHire }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Province_Name}}</td>
                              <td>{{ employee.provinceName }}</td>
                            </tr>
                            <!-- <tr>
                              <td>{{lang.Country}}</td>
                              <td>{{ employee.country }}</td>
                            </tr> -->


                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- wallet Information-->
                <!-- <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="wallet?.wallet==true">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>Wallet Information</span>
                    </div>
                    <div class="_card_body enroll_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/wallet.jpg" />
                      </div>
                      <div class="_card_body_body py-2" style="overflow-x:auto; padding-right:5px;">
                        <table border="0" class="table border-0 bg-transparent">
                          <tbody class="d-inline">
                            <tr>
                              <td>Wallet Type</td>
                              <td>{{ wallet?.walletConfig?.walletType }}</td>
                            </tr>
                            <tr>
                              <td>Wallet Amount</td>
                              <td>{{ formatPrice(wallet?.walletConfig?.walletAmount) }}</td>
                            </tr>
                            <tr>
                              <td>Carry Forward Amount</td>
                              <td>{{ wallet?.walletConfig?.carryForwardUnusedAmount==true?'Yes':'No' }}</td>
                            </tr>
                            <tr>
                              <td>Allocation</td>
                              <td>{{ wallet?.walletConfig?.rolloverAllocationPeriod }}</td>
                            </tr>
                            <tr>
                              <td>Intial Balance Setup</td>
                              <td>{{ wallet?.walletConfig?.initialBalanceSetup }}</td>
                            </tr>
                            <tr>
                              <td>Coverage Percentage</td>
                              <td>{{ wallet?.walletConfig?.coveragePercentage }}%</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div> -->

                  <div *ngIf="roeAgreementSigned" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card paymentCard2 p-0">
                    <div class="_card_title">
                      <span class="text-white ftsize12">{{
                        lang.Downloads
                        }}</span>
                      <!-- <span class="text-white">{{currentIndex}} of 3</span> -->
                      <!-- <span id="downloadall text-end" class="ftsize12">
                                    <img src="/assets/img/download2.png" role="button"
                                      width="45%" data-bs-toggle="tooltip"
                                      data-bs-placement="top" title="Download All">
                                  </span> -->
                    </div>
                    <div class="mt-2">
                      <section id="tranding" class="tranding-style">
                        <div class="swiper-container tranding-slider">
                          <div class="swiper-wrapper">
                            <!-- first slider member ship booklets -->
                            <div class="swiper-slide tranding-slide">
                              <div class="card activecard p-0">
                                <div class="card-header p-0">
                                  <div class="imagetext">
                                    <!-- <span>{{lang.health_plan_booklets_cp}}</span> -->
                                    <span class="ftsize12">{{lang.Member_Booklets}}</span>
                                  </div>
                                  <img id="image" src="/assets/img/booklets.png" width="100%" />
                                  <!-- <ng-template #backgroundImage>
                                                <div>
                                                  <img id="image"
                                                    src={{logo.booklets.image}}
                                                    width="100%">
                                                </div>
                                              </ng-template> -->
                                </div>
                                <div class="card-body">
                                  <div class="planBody tileheight2">
                                    <div class="row mb-1" *ngFor="
                                        let booklet of corporateBooklets;
                                        let i = index
                                      ">
                                      <div class="col-9 ftsize12">
                                        <div>{{ booklet.name }}</div>
                                        <!-- <div>{{booklet.description}}</div> -->
                                      </div>
                                      <div class="col-3 d-flex ps-0">
                                        <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                          role="button" data-bs-toggle="tooltip" data-bs-placement="top" title="View"
                                          (click)="viewBooklet(booklet, i)" />&nbsp;
                                        <img src="/assets/img/download2.png" class="viewDownloadIcon cursor-pointer"
                                          role="button" data-bs-toggle="tooltip" data-bs-placement="top"
                                          title="Download" (click)="
                                            downloadHpbooklet(booklet, i)
                                          " />
                                      </div>
                                      <!-- <div class="col-1 px-2">
                                                          <img src="/assets/img/download2.png"
                                                              role="button" (click)="downloadHpbooklet(booklet)">
                                                      </div> -->
                                    </div>
                                    <div class="ms-2 text-center" *ngIf="corporateBooklets.length == 0">
                                      {{lang.No_Data_Available}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- second slider Member ship card -->
                            <div class="swiper-slide download-tranding-slide">
                              <div class="card activecard p-0">
                                <div class="card-header p-0">
                                  <div class="imagetext">
                                    <!-- <span>{{lang.membweship_cards}}</span> -->
                                    <span class="ftsize12">{{lang.Membership_Cards}}</span>
                                  </div>
                                  <img id="image" src="/assets/img/MemberIDCards.png" width="100%" />

                                  <!-- <img id="image" *ngIf="logo.healthCards.image!='';else backgroundImage" src={{logo.healthCards.image}} width="100%"> -->
                                  <!-- <ng-template #backgroundImage>
                                                <div>
                                                  <img id="image" src={{logo.healthCards.image}} width="100%">
                                                </div>
                                              </ng-template> -->
                                </div>
                                <div class="card-body">
                                  <div class="planBody tileheight2">
                                    <div class="ms-2" *ngIf="
                                        memberCards && memberCards.length == 0
                                      ">
                                      {{lang.No_Membership_Cards_available}}
                                    </div>
                                    <div *ngFor="
                                        let hic of memberCards;
                                        let i = index
                                      " class="row" style="padding-left: 5px">
                                      <div class="col-12 d-flex">
                                        <div class="col-9 ms-0">
                                          {{ hic.name }}
                                          <span *ngIf="hic.bulkCustomer == true">{{lang.Group}}</span>
                                        </div>
                                        <div class="col-2 d-flex ps-0 mt-1">
                                          <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                            role="button" data-bs-toggle="modal" data-bs-target="#viewBooklet-modal"
                                            data-bs-placement="top" title="View" (click)="viewHealthCard(hic)" />&nbsp;
                                          <img *ngIf="hic.cards.length > 0" src="/assets/img/download2.png"
                                            class="viewDownloadIcon cursor-pointer" role="button"
                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Download" (click)="
                                              DownloadContractMemberBooklets(
                                                hic.cards
                                              )
                                            " />
                                        </div>
                                      </div>
                                    </div>

                                    <!-- <ng-container
                                                  *ngFor="let hic of memberCards; let i = index">

                                                  <div class="col-6  d-flex ps-0"
                                                    *ngIf="i % 2 === 0">
                                                    <div
                                                      class="col-9  ms-0 ps-0">
                                                      {{hic.name}} <span
                                                        *ngIf="hic.bulkCustomer==true">{{lang.Group}}</span>
                                                    </div>
                                                    <div class="col-2 d-flex ps-0 mt-1">
                                                      <img src="/assets/img/view2.png"
                                                        class="viewDownloadIcon cursor-pointer"
                                                         role="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#viewBooklet-modal"
                                                        data-bs-placement="top"
                                                        title="View"
                                                        (click)="viewHealthCard(hic)">&nbsp;
                                                      <img src="/assets/img/download2.png"
                                                        class="viewDownloadIcon cursor-pointer"

                                                        role="button"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Download"
                                                        (click)="DownloadContractMemberBooklets(hic.cards)">
                                                    </div>
                                                  </div>

                                                  <div class="col-6  d-flex ps-0"
                                                    *ngIf="i % 2 !== 0 || i === memberCards.length - 1">
                                                    <div
                                                      class="col-9  ms-0 ps-0">
                                                      {{hic.name}} <span
                                                        *ngIf="hic.bulkCustomer==true">{{lang.Group}}</span>
                                                    </div>
                                                    <div class="col-2 d-flex ps-0 mt-1">
                                                      <img src="/assets/img/view2.png"
                                                        class="viewDownloadIcon cursor-pointer"
                                                         role="button"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#viewBooklet-modal"
                                                        data-bs-placement="top"
                                                        title="View"
                                                        (click)="viewHealthCard(hic)">&nbsp;
                                                      <img src="/assets/img/download2.png"
                                                        class="viewDownloadIcon cursor-pointer"

                                                        role="button"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Download"
                                                        (click)="DownloadContractMemberBooklets(hic.cards)">
                                                    </div>
                                                  </div>
                                                </ng-container> -->

                                    <!-- <div class="downloads ms-2">

                                                </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- third slider my applications -->
                            <div class="swiper-slide download-tranding-slide">
                              <div class="card activecard p-0">
                                <div class="card-header p-0">
                                  <div class="imagetext">
                                    <!-- <span>{{lang.myApplications}}</span> -->
                                    <span class="ftsize12">{{lang.My_Contracts}}</span>
                                  </div>
                                  <img id="image" src="/assets/img/MyApplications.png" width="100%" />
                                  <!-- <img id="image" *ngIf="logo.roe.image!='';else backgroundImage" src={{logo.roe.image}} width="100%">
                                              <ng-template #backgroundImage>
                                                <div>
                                                  <img id="image" src={{logo.roe.image}} width="100%">
                                                </div>
                                              </ng-template> -->
                                </div>
                                <div class="card-body">
                                  <div class="planBody tileheight2">
                                    <div class="downloads">
                                      <!-- <div class="row pb-1">
                                                          <div class="col-12 text-end "><a (click)="downloadRoe()" role="button"><u>Download All</u></a></div>
                                                      </div> -->
                                      <div class="row">
                                        <div class style="
                                            display: flex;
                                            padding-left: 15px;
                                          " *ngIf="
                                            paymentMethodHeader ==
                                            'Pre-Authorized Debit (PAD)'
                                          ">
                                          <div class="col-9">
                                            <label for>{{lang.PAD_Agreement}} </label>
                                          </div>
                                          <div class="col-3" style="
                                              display: flex;
                                              text-wrap: nowrap;
                                            ">
                                            <span class>
                                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                                role="button" title="View" (click)="openPADModal()" />

                                              <img src="/assets/img/download2.png"
                                                class="viewDownloadIcon cursor-pointer ms-1" role="button"
                                                data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                                (click)="DownloadContractPAD()" />
                                            </span>
                                          </div>
                                        </div>
                                        <div class style="
                                            display: flex;
                                            padding-left: 15px;
                                          ">
                                          <div class="col-9">
                                            <label for class="ftsize12">{{lang.ROE_Agreement}}
                                            </label>
                                          </div>
                                          <div class="col-3" style="
                                              display: flex;
                                              text-wrap: nowrap;
                                            ">
                                            <span class="">

                                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                                role="button" title="View" (click)="openROEModal()" />
                                               
                                              <img src="/assets/img/download2.png"
                                                class="viewDownloadIcon cursor-pointer ms-1" role="button"
                                                title="Download" (click)="DownloadROEContract()" />
                                                  
                                            </span>
                                          </div>
                                        </div>

                                        <div *ngFor="
                                            let employee of employeeList1;
                                            let i = index
                                          " class style="
                                            display: flex;
                                            padding-left: 15px;
                                          ">
                                          <div *ngIf="
                                              employee.employeeROEs &&
                                              employee.employeeROEs.length > 0
                                            " class="col-9">
                                            <label for class="ftsize12">{{
                                              employee.firstName +
                                              " " +
                                              employee.lastName
                                              }}
                                            </label>
                                          </div>
                                          <div *ngIf="
                                              employee.employeeROEs &&
                                              employee.employeeROEs.length > 1
                                            " class="col-3 ps-0" style="
                                              display: flex;
                                              text-wrap: nowrap;
                                            ">
                                            <span>
                                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                                role="button" data-bs-toggle="tooltip" data-bs-placement="top"
                                                title="View" (click)="
                                                  openEmployeeROEModal(
                                                    employee.employeeROEs
                                                  )
                                                " />
                                            </span>
                                          </div>

                                          <div *ngIf="
                                              employee.employeeROEs &&
                                              employee.employeeROEs.length == 1
                                            " class="col-3" style="
                                              display: flex;
                                              text-wrap: nowrap;
                                            ">
                                            <span>
                                              <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer"
                                                role="button" data-bs-toggle="tooltip" data-bs-placement="top"
                                                title="View" (click)="
                                                  getROEDetails(
                                                    employee.employeeROEs[0]
                                                  )
                                                " />
                                            </span>
                                            <span>
                                              <img src="/assets/img/download2.png"
                                                class="viewDownloadIcon cursor-pointer ms-1" role="button"
                                                data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                                                (click)="
                                                  DownloadROEContract2(
                                                    employee.employeeROEs[0]
                                                      .link
                                                  )
                                                " />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="controlCard1">
                            <div class="tranding-slider-control">
                              <div class="swiper-button-prev2 ftsize20">
                                <i class="fa fa-angle-left"></i>
                              </div>

                              <div class="swiper-pagination" id="paginationCount2"></div>
                              <div class="swiper-button-next2 ftsize20">
                                <i class="fa fa-angle-right"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>


                 <!---Corporate Tiers--->  
<div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="corporateTiers?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Corporate_Tier_Plans}}

                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="_card_body">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/invoices.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-2 _card_body_body tileMarginDown" *ngFor="
                          let tier of corporateTiers;
                          let i = index
                        ">
                          <div *ngIf="
                            tier?.plans?.paidByCompany?.length == 0 &&
                            tier?.plans?.coveredByCompany?.length == 0 &&
                            tier?.plans?.paidByEmployee?.length == 0; else showtable"
                            class="d-flex flex-column"
                          >
                            <span><strong>{{tier?.name}}</strong> ({{tier?.status}})</span>
                            <span>{{lang.No_Tier_Plans_to_show}}</span>
                          </div>
                          <ng-template #showtable>
                            <div class="d-flex justify-content-between align-items-center"
                            *ngIf="setUplevelofCoverage==true"
                            >
                              <span><strong>{{tier?.name}}</strong> ({{tier?.status}})</span>
                              <span class="spanCopy ftsize12 d-flex flex-nowrap" style="border: none; padding-right: 0px;">
                                <span *ngIf="tier?.status.toLowerCase()=='active'">
                                  <a class="spanCopy ftsize12 text-nowrap" target="_blank" href="{{ tier?.signupLink }}"><span>
                                    <!-- {{lang.Sign_up_Link}} -->
                                     Enrollment Link
                                    </span></a>
                                </span>
                                <span>
                                  <button 
                                    style="border: none; background: transparent; padding-right: 0px" 
                                    class="spanCopy1 btnSizes ms-1 ftsize12 cursor-pointer"
                                    (click)="copyToClipboard(tier?.signupLink)" 
                                    data-bs-toggle="tooltip" 
                                    data-bs-placement="top" 
                                    title="Copy">
                                    <a href style="
                                      pointer-events: none;
                                      font-family: sans-serif;
                                      text-decoration: none !important;
                                    ">
                                      <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                                  </button>
                                </span>
                              </span>
                            </div>
                            <table border="0" class="table border-0 bg-transparent tiers">
                              <thead>
                                <tr>
                                  <th>Plan Level</th>
                                  <th>Plan Type</th>
                                </tr>
                              </thead>
                              <tbody class="d-inline">
                                <tr *ngFor="let plan of tier?.plans?.paidByCompany">
                                  <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                  <td>Core</td>
                                </tr>
                                <tr *ngFor="let plan of tier?.plans?.coveredByCompany">
                                  <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                  <td>Upgrade</td>
                                </tr>
                                <tr *ngFor="let plan of tier?.plans?.paidByEmployee">
                                  <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                  <td>Voluntary</td>
                                </tr>
                              </tbody>
                            </table>
                          </ng-template>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Corporate Tier Plans -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    corporateTiers?.length > 1 ||
                    corporateTiers?.length == 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Corporate_Tier_Plans}}
                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="mt-2">
                        <div *ngIf="corporateTiers?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let tier of corporateTiers;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/invoices.png" style="
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                      " />
                                    </div>
                                    <div style="padding-left: 10px" class="card-body tileMarginDown py-2 tileheight">
                                      <div class="py-2 px-2 _card_body_body tileMarginDown">
                                        <div *ngIf="
                                          tier?.plans?.paidByCompany?.length == 0 &&
                                          tier?.plans?.coveredByCompany?.length == 0 &&
                                          tier?.plans?.paidByEmployee?.length == 0; else showtable"
                                          class="d-flex flex-column"
                                        >
                                          <span><strong>{{tier?.name}}</strong> ({{tier?.status}})</span>
                                          <span>{{lang.No_Tier_Plans_to_show}}</span>
                                        </div>
                                        <ng-template #showtable>
                                          <div class="d-flex justify-content-between align-items-center">
                                            <span><strong>{{tier?.name}}</strong> ({{tier?.status}})</span>
                                            <span class="spanCopy ftsize12 d-flex flex-nowrap" style="border: none; padding-right: 0px;">
                                              <span *ngIf="tier?.status.toLowerCase()=='active'">
                                                <a class="spanCopy ftsize12 text-nowrap" target="_blank" href="{{ tier?.signupLink }}"><span>
                                                  <!-- {{lang.Sign_up_Link}} -->
                                                   Enrollment Link
                                                  </span></a>
                                              </span>
                                              <span>
                                                <button 
                                                  style="border: none; background: transparent; padding-right: 0px" 
                                                  class="spanCopy1 btnSizes ms-1 ftsize12 cursor-pointer"
                                                  (click)="copyToClipboard(tier?.signupLink)" 
                                                  data-bs-toggle="tooltip" 
                                                  data-bs-placement="top" 
                                                  title="Copy">
                                                  <a href style="
                                                    pointer-events: none;
                                                    font-family: sans-serif;
                                                    text-decoration: none !important;
                                                  ">
                                                    <img src="../../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                                                </button>
                                              </span>
                                            </span>
                                          </div>
                                          <table border="0" class="table border-0 bg-transparent tiers">
                                            <thead>
                                              <tr>
                                                <th>Plan Level</th>
                                                <th>Plan Type</th>
                                              </tr>
                                            </thead>
                                            <tbody class="d-inline">
                                              <tr *ngFor="let plan of tier?.plans?.paidByCompany">
                                                <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                                <td>Core</td>
                                              </tr>
                                              <tr *ngFor="let plan of tier?.plans?.coveredByCompany">
                                                <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                                <td>Upgrade</td>
                                              </tr>
                                              <tr *ngFor="let plan of tier?.plans?.paidByEmployee">
                                                <td>{{plan?.planLevelName}} {{plan?.coverage && plan?.coverage!=''?(getCoverage(plan?.coverage)):''}}</td>
                                                <td>Voluntary</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </ng-template>

                                      </div>
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="corporateTiers.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-----Wallet Information--->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="corporateTiers?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        Wallet Information

                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="_card_body" *ngIf="corporateTiers?.length == 1">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/wallet.jpg"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-2 _card_body_body tileMarginDown" *ngFor="
                            let tier of corporateTiers;
                            let i = index
                          ">
                          <table border="0" class="table border-0 bg-transparent" *ngIf="tier?.wallet==true">
                            <tbody class="d-inline">
                              <tr *ngIf="setUplevelofCoverage">
                                <td>Tier Name</td>
                                <td>{{ tier?.name }}</td>
                              </tr>
                              <tr>
                                <td>Wallet Type</td>
                                <td>{{ tier?.walletConfig?.walletType }}</td>
                              </tr>
                              <tr>
                                <td>Wallet Amount</td>
                                <td>{{ formatPrice(tier?.walletConfig?.walletAmount) }}</td>
                              </tr>
                              <tr>
                                <td>Carry Forward Amount</td>
                                <td>{{ tier?.walletConfig?.carryForwardUnusedAmount==true?'Yes':'No' }}</td>
                              </tr>
                              <tr>
                                <td>Allocation</td>
                                <td>{{ tier?.walletConfig?.rolloverAllocationPeriod }}</td>
                              </tr>
                              <tr>
                                <td>Intial Balance Setup</td>
                                <td>{{ tier?.walletConfig?.initialBalanceSetup }}</td>
                              </tr>
                              <tr>
                                <td>Coverage Percentage</td>
                                <td>{{ tier?.walletConfig?.coveragePercentage }}%</td>
                              </tr>
                            </tbody>
                          </table>

                          <table border="0" class="table border-0 bg-transparent" *ngIf="tier?.wallet!=true">
                            <tbody class="d-inline">
                              <tr *ngIf="setUplevelofCoverage">
                                <td>Tier Name</td>
                                <td>{{ tier?.name }}</td>
                              </tr>
                              <tr>
                                <td [colSpan]="2">Wallet has not been configured.</td>
                                <!-- <td>{{ formatPrice(wallet?.walletConfig?.walletAmount) }}</td> -->
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Wallet Information -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    corporateTiers?.length > 1 ||
                    corporateTiers?.length == 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        Wallet Information
                        <!-- <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button> -->
                      </div>
                      <div class="mt-2">
                        <div *ngIf="corporateTiers?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let tier of corporateTiers;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/wallet.jpg" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div style="padding-left: 10px" class="card-body tileMarginDown py-2 tileheight">
                                      <table border="0" class="table border-0 bg-transparent" *ngIf="tier?.wallet==true">
                                        <tbody class="d-inline">
                                          <tr *ngIf="setUplevelofCoverage">
                                            <td>Tier Name</td>
                                            <td>{{ tier?.name }}</td>
                                          </tr>
                                          <tr>
                                            <td>Wallet Type</td>
                                            <td>{{ tier?.walletConfig?.walletType }}</td>
                                          </tr>
                                          <tr>
                                            <td>Wallet Amount</td>
                                            <td>{{ formatPrice(tier?.walletConfig?.walletAmount) }}</td>
                                          </tr>
                                          <tr>
                                            <td>Carry Forward Amount</td>
                                            <td>{{ tier?.walletConfig?.carryForwardUnusedAmount==true?'Yes':'No' }}</td>
                                          </tr>
                                          <tr>
                                            <td>Allocation</td>
                                            <td>{{ tier?.walletConfig?.rolloverAllocationPeriod }}</td>
                                          </tr>
                                          <tr>
                                            <td>Intial Balance Setup</td>
                                            <td>{{ tier?.walletConfig?.initialBalanceSetup }}</td>
                                          </tr>
                                          <tr>
                                            <td>Coverage Percentage</td>
                                            <td>{{ tier?.walletConfig?.coveragePercentage }}%</td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <table border="0" class="table border-0 bg-transparent" *ngIf="tier?.wallet!=true">
                                        <tbody class="d-inline">
                                          <tr *ngIf="setUplevelofCoverage">
                                            <td>Tier Name</td>
                                            <td>{{ tier?.name }}</td>
                                          </tr>
                                          <tr>
                                            <td [colSpan]="2">Wallet has not been configured.</td>
                                            <!-- <td>{{ formatPrice(wallet?.walletConfig?.walletAmount) }}</td> -->
                                          </tr>
                                        </tbody>
                                      </table>
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="corporateTiers.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Employees -->


                <!-- *********settings******** -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      {{lang.Settings}}
                      <button data-bs-toggle="modal" data-bs-target="#settingsEdit" class="addgroupadmininfoemp" *ngIf="!formConfigLoading">
                        <strong>
                          <!-- <i class="bi bi-pencil-square" style="
                              color: #ffffff;
                              cursor: pointer;
                              margin-right: 5px;
                            " title="Edit"></i> -->
                            {{lang.Edit}}</strong>
                      </button>
                      <div class="is-loading col-3" *ngIf="formConfigLoading">
                        <p></p>
                      </div>
                    </div>

                    <div class="_card_body">
                      <div class="_card_body_image">
                        <img src="./../assets/img/Proposal_Progress.png" />
                      </div>
                      <div class="_card_body_body tileMarginDown py-2 px-1">
                        <table border="0" class="table border-0 bg-transparent">
                          <tbody class="d-inline">
                            <tr>
                              <td>{{lang.Wait_time}}</td>
                              <td class="text-nowrap">{{ waitTime }} {{lang.Months}}</td>
                            </tr>
                            <tr>
                              <!-- <td>{{lang.Wait_time_for_initial_signup}}</td> -->
                              <td>Wait time for initial enrollment</td>
                              <td>
                                {{
                                corporateEmployeesInitialSignupWaittime
                                ? "Yes"
                                : "None"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{lang.Payment_method}}</td>
                              <td>
                                {{
                                paymentMethod == "CREDIT_CARD" ? "CC"
                                : paymentMethod == "NONE" ? "None" 
                                : paymentMethod
                                }}
                              </td>
                            </tr>
                            <tr>
                              <!-- <td>{{lang.Show_employer_name_for_signup}}</td> -->
                              <td>Show employer name for enrollment</td>
                              <td>{{ requireEmployeeName ? "Yes" : "No" }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Create_classification_tiers_of_coverage}}</td>
                              <td>{{ setUplevelofCoverage ? "Yes" : "No" }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Advisor information -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span> {{lang.Advisor_Information}}</span>
                    </div>
                    <div class="_card_body advisor_card">
                      <div class="_card_body_image">
                        <img class="widHigSvgIcon" src="./../assets/img/booklets.png" />
                      </div>
                      <div class="_card_body_body p-2" *ngFor="let advisors of advisorsData">
                        <div>
                          <span class="ftsize12">
                            <!-- <b>Name:</b>  -->
                            <img class="widHigSvgIcon" src="./../assets/img/planholder.svg" alt />
                          </span>
                          <span class="ms-2">
                            {{ advisors.name }}
                          </span>
                        </div>
                        <div class="mt-1 d-flex">
                          <span class="ftsize12">
                            <!-- <b>Email:</b> -->
                            <img class="widHigSvgIcon" src="./../assets/img/email.svg" alt />
                          </span>
                          <span class="ms-2 ftsize12 email-truncate" title="{{ advisors.email }}">
                            <!-- {{
                                   advisors.email.length > 24 ?
                                   advisors.email.slice(0, 6) + '...'
                                   +advisors.email.slice(-6) :
                                   advisors.email
                                   }} -->
                            <!-- {{
                            advisors.email.length > 24
                            ? advisors.email.slice(0, 24) + "..."
                            : advisors.email
                            }} -->
                            <!-- {{advisors.email}} -->
                            
    <a
      href="javascript:void(0)"
      (click)="copyToClipboard2(advisors.email)"
      style="text-decoration: underline; color: blue; cursor: pointer; font-size: 12px;"
      title="Click to copy">
      {{ advisors.email }}
    </a>
  
                          </span>
                        </div>
                        <div class="mt-1">
                          <span class="ftsize12">
                            <!-- <b>Phone Number:</b> -->
                            <img class="widHigSvgIcon" src="./../assets/img/tel.svg" alt />
                          </span>
                          <span class="ms-2 ftsize12">{{
                            advisors.phone &&
                            advisors.phone.split(")")[0] +
                            ") " +
                            advisors.phone.split(")")[1]
                            }}
                          </span>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                  </div> -->
                    </div>
                  </div>
                </div>

                




               
                <!-- Group benefits invoices -->

               
                <!-- Group benefits plans summary -->

                <div *ngIf="roeAgreementSigned" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div>
                    <div class="_card">
                      <div class="_card_title ftsize12">
                        <span>{{lang.Group_Benefitz_Plan_Summary}}</span>
                      </div>
                      <div class *ngIf="dashboardMyplans.length > 1">
                        <div class="mt-2">
                          <section id="tranding" class="tranding-style" *ngIf="dashboardMyplans.length > 1">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="let plan of dashboardMyplans">
                                  <div class="card activecard p-0 pb-0">
                                    <div class="card-header p-0">
                                      <div class="imagetext">
                                        <span *ngIf="plan.logo.includes('null')">{{ plan.planLevelName }}</span>
                                      </div>
                                      <img id="image" style="
                                          border-top-left-radius: 6px;
                                          border-top-right-radius: 6px;
                                        " *ngIf="
                                          !plan.logo.includes('null');
                                          else backgroundImage
                                        " src="{{ plan?.logo }}" width="100%" />
                                      <ng-template #backgroundImage>
                                        <div>
                                          <img id="image" style="
                                              border-top-left-radius: 6px;
                                              border-top-right-radius: 6px;
                                            "
                                            src="https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/plans/DependentCriticalIllness.png"
                                            width="100%" />
                                        </div>
                                      </ng-template>
                                    </div>
                                    <div class="_card_body_body py-0 px-1" style="
                                        overflow-y: scroll;
                                        border-bottom-left-radius: 10px;
                                        border-bottom-right-radius: 10px;
                                      " [style.background-color]="
                                        plan
                                      ">
                                      <div class="planBody">
                                        <div *ngFor="
                                            let feature of plan.planLevelFeatures
                                          ">
                                          <div class="ftsize12" style="font-weight: bold">
                                            {{ feature.feature.name }}
                                          </div>
                                          <p style="text-align: left" class="ftsize12"
                                            [innerHTML]="feature.description"></p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1" *ngIf="dashboardMyplans.length > 0">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left"></i>
                                  </div>

                                  <div class="swiper-pagination" id="paginationCount2"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <!-- <div class = "_card_body_footer">
                  </div> -->
                      </div>

                      <div class="_card_body gbps_tile" *ngIf="
                          dashboardMyplans.length == 1 ||
                          dashboardMyplans.length == 0
                        ">
                        <div>
                          <div class="text-center" style="padding: 20px" *ngIf="dashboardMyplans.length == 0">
                            {{lang.No_Data_Available}}
                          </div>
                          <div *ngIf="dashboardMyplans.length == 1">
                            <div *ngFor="
                                let plan of dashboardMyplans;
                                let i = index
                              ">
                              <div class="p-0 pb-0" [style.background-color]="plan">
                                <div class="card-header p-0">
                                  <div class>
                                    <span *ngIf="
                                        plan.logo == '' &&
                                        plan.logo.includes('null')
                                      ">{{ plan.planLevelName }}</span>
                                  </div>
                                  <img id="image" style="
                                      border-top-left-radius: 6px;
                                      border-top-right-radius: 6px;
                                    " *ngIf="
                                      plan.logo != '' &&
                                        !plan.logo.includes('null');
                                      else backgroundImage
                                    " src="{{ plan.logo }}" width="100%" />
                                  <ng-template #backgroundImage>
                                    <div>
                                      <img id="image" style="
                                          border-top-left-radius: 6px;
                                          border-top-right-radius: 6px;
                                        "
                                        src="https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/plans/DependentCriticalIllness.png"
                                        width="100%" />
                                    </div>
                                  </ng-template>
                                </div>
                                <div class="py-2 px-1 groupBenefitstileheight">
                                  <div class="ms-2">
                                    <!-- <div class="card-body tileheight"
                            style="overflow-y: scroll; border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;"
                            [style.background-color]="plan.backgroundColor"> -->
                                    <!-- <div class="planBody "> -->
                                    <div *ngFor="
                                        let feature of plan.planLevelFeatures
                                      ">
                                      <div class="ftsize12" style="font-weight: bold">
                                        {{ feature.feature.name }}
                                      </div>
                                      <p style="text-align: left" class="ftsize12" [innerHTML]="feature.description">
                                      </p>
                                    </div>
                                    <!-- </div> -->
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class = "_card_body_footer">
                  </div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- *********Group Benefits Resources******** -->

                <div *ngIf="roeAgreementSigned" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      {{lang.Group_Benefitz_Resources}}
                    </div>
                    <div class="mt-2" *ngIf="
                        corporateMyResorces.length > 1 ||
                        corporateMyResorces.length == 0
                      ">
                      <section id="tranding" *ngIf="corporateMyResorces.length > 1">
                        <div class="swiper-container tranding-slider">
                          <div class="swiper-wrapper">
                            <div class="swiper-slide tranding-slide" *ngFor="let benefit of corporateMyResorces">
                              <div class="card activecard p-0" style="width: '100%'">
                                <div class="card-header p-0">
                                  <div class="imagetext">
                                    <span *ngIf="benefit.logo.includes('null')">{{ benefit.name }}</span>
                                  </div>
                                  <img id="image" *ngIf="
                                      !benefit.logo.includes('null');
                                      else backgroundImage
                                    " src="{{ benefit.logo }}" width="100%" />
                                  <ng-template #backgroundImage>
                                    <div>
                                      <img id="image"
                                        src="https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/plans/DependentCriticalIllness.png"
                                        width="100%" />
                                    </div>
                                  </ng-template>
                                </div>
                                <div class="_card_body_body py-2 px-1" [style.background-color]="
                                    benefit
                                  ">
                                  <div class="benefitplanBody">
                                    <p class="ftsize12" style="text-align: left" [innerHTML]="benefit.content"></p>
                                  </div>
                                  <div>
                                    <button #videoPopup type="button" hidden data-bs-target="#videoform"
                                      data-bs-toggle="modal"></button>
                                    <button #iframePopup type="button" hidden data-bs-target="#iframeform"
                                      data-bs-toggle="modal"></button>
                                    <button #equitablePopup type="button" hidden data-bs-target="#equitable"
                                      data-bs-toggle="modal"></button>
                                    <button #supportPopup type="button" hidden data-bs-target="#support"
                                      data-bs-toggle="modal"></button>
                                  </div>
                                </div>
                                <div class="card-footer corosalfooter py-0" [style.background-color]="benefit.color">
                                  <div class="row" *ngIf="benefit.footer.length > 0">
                                    <div class="col-12 text-center testpera">
                                      <div [innerHTML]="benefit.footer"></div>
                                      <!-- <p style="text-align: left;font-size: 10px;" [innerHTML]="benefit.footer"></p> -->
                                      <!--
                                    <a href="" class="text-white "
                                        data-bs-target="#Equitqble" data-bs-toggle="modal">{{benefit.footer}}</a> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="controlCard1" *ngIf="dashboardMyplans.length > 0">
                            <div class="tranding-slider-control">
                              <div class="swiper-button-prev2 ftsize20">
                                <i class="fa fa-angle-left"></i>
                              </div>
                              <div class="swiper-pagination" id="paginationCount2"></div>
                              <div class="swiper-button-next2 ftsize20">
                                <i class="fa fa-angle-right"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      <div class *ngIf="corporateMyResorces.length == 0">
                        <div class="_card_body text-center" style="height: 39vh; padding: 20px">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>

                    <div *ngIf="corporateMyResorces.length == 1" style="margin-top: 0.8vw">
                      <div class="_card_body" *ngFor="
                          let benefit of corporateMyResorces;
                          let i = index
                        ">
                        <!-- image -->
                        <div style="height: 10vh">
                          <div>
                            <span *ngIf="benefit.logo.includes('null')">{{
                              benefit.name
                              }}</span>
                          </div>

                          <img id="image" *ngIf="
                              !benefit.logo.includes('null');
                              else backgroundImage
                            " src="{{ benefit.logo }}" width="100%" />
                          <ng-template #backgroundImage>
                            <div>
                              <img id="image"
                                src="https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/app/resources/images/plans/DependentCriticalIllness.png"
                                style="
                                  border-top-left-radius: 6px;
                                  border-top-right-radius: 6px;
                                " width="100%" />
                            </div>
                          </ng-template>
                        </div>

                        <!-- body -->
                        <div class="gbrHeight">
                          <p class="ftsize12" style="text-align: left" [innerHTML]="benefit.content"></p>
                          <div>
                            <button #videoPopup type="button" hidden data-bs-target="#videoform"
                              data-bs-toggle="modal"></button>
                            <button #iframePopup type="button" hidden data-bs-target="#iframeform"
                              data-bs-toggle="modal"></button>
                            <button #equitablePopup type="button" hidden data-bs-target="#equitable"
                              data-bs-toggle="modal"></button>
                            <button #supportPopup type="button" hidden data-bs-target="#support"
                              data-bs-toggle="modal"></button>
                          </div>
                        </div>

                        <!-- footer -->

                        <div style="height: 3vh" [style.background-color]="benefit"
                          *ngIf="benefit.footer.length > 0">
                          <div class="text-center">
                            <div [innerHTML]="benefit.footer"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!---Group Contacts-->


                 <!-- {{lang.Group_Contacts}} single -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="groupContacts.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Group_Contacts}}
                        <button class="addgroupadmininfoemp" (click)="basicModalOpen()" *ngIf="!formConfigLoading">
                          <strong>+&nbsp;{{lang.Add}}</strong>
                        </button>
                        <div class="is-loading col-3" *ngIf="formConfigLoading">
                          <p></p>
                        </div>
                      </div>
                      <div class="_card_body">
                        <div *ngIf="groupContacts.length == 1">
                          <div *ngFor="let admin of groupContacts; let i = index">
                            <div class="p-0 pb-0">
                              <div class="_card_body_image p-0">
                                <img id="image" src="/assets/img/Group_contacts.png" style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                  " />
                              </div>
                              <div class="py-2 px-1 groupContactsBgClr _card_body_body">
                                <div style="
                                    float: right;
                                    text-align: right;
                                    display: flex;
                                    margin-top: 0px;
                                    margin-bottom: 10px;
                                  " class="ftsize16">
                                  &nbsp;&nbsp;
                                  <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#basicModaledit"
                                    (click)="editadmin(admin, i)" style="color: #1429a9; cursor: pointer"
                                    title="Edit"></i>
                                  &nbsp;&nbsp;
                                  <i class="bi bi-trash-fill redClr" (click)="deleteadmin(admin, i)"
                                    style="color: red; cursor: pointer" title="Delete"></i>
                                </div>
                                <div class="ms-2">
                                  <div class="mt-2">
                                    <img src="./../assets/img/planholder.svg" alt class="widHigSvgIcon"
                                      data-bs-toggle="tooltip" data-bs-placement="top" title="Name" /><span
                                      class="ms-2">{{ admin.firstName }}
                                      {{ admin.lastName }}</span>
                                  </div>

                                  <div class="mt-2" *ngIf="admin.phoneNum">
                                    <img src="./../assets/img/mobile.svg" alt class="widHigSvgIcon"
                                      data-bs-toggle="tooltip" data-bs-placement="top" title="Phone" />
                                    <span class="ms-2">{{
                                      admin.phoneNum
                                      }}</span>
                                  </div>
                                  <div class="mt-2 d-flex">
                                    <img src="./../assets/img/email.svg" alt class="widHigSvgIcon"
                                      data-bs-toggle="tooltip" data-bs-placement="top" title="Email" />
                                    <span title="{{ admin?.email }}" class="ms-2 email-truncate" *ngIf="showMaskedAdminMail"
                                      style="cursor: pointer" (click)="toggleGroupAdminEmailClick(admin)">
                                      <!-- {{
                                                                                admin.email.length > 24
                                                                                ? admin.email.slice(0, 6) +
                                                                                "..." +
                                                                                admin.email.slice(-6)
                                                                                : admin.email
                                                                                }} -->
                                        <!-- {{admin.email}} -->
                                      <!-- <span *ngIf="admin.emailClicked">{{
                                        admin.email
                                        }}</span>
                                      <span *ngIf="!admin.emailClicked">{{
                                        admin.maskedEmail ?? admin.email
                                        }}</span> -->
                                         
    <a
      href="javascript:void(0)"
      (click)="copyToClipboard2(admin.email)"
      style="text-decoration: underline; color: blue; cursor: pointer; font-size: 12px;"
      title="Click to copy">
      {{ admin.email }}
    </a>
  

                                    </span>
                                    <!-- <span class="ms-2">{{admin.email}}</span> -->
                                  </div>
                                  <div class="mt-2">
                                    <img src="./../assets/img/RoleImage.png" alt class="widHigSvgIcon"
                                      data-bs-toggle="tooltip" data-bs-placement="top" title="Role" />
                                    <span class="ms-2">
                                      <span *ngIf="admin.role == 'CORPORATE_ACCOUNTANT'"
                                        class="text-capitalize">{{lang.Accountant}}</span>
                                      <span *ngIf="admin.role == 'CORPORATE_EXECUTIVE'"
                                        class="text-capitalize">{{lang.Executive}}</span>
                                      <span *ngIf="admin.role =='CORPORATE_PLAN_ADMINISTRATOR'"
                                        class="text-capialize">{{lang.Plan_Administrator}}</span>
                                      <span *ngIf="admin.role == 'CORPORATE_ADMIN'"
                                        class="text-capitalize">{{lang.System_Administrator}}</span>
                                      <span *ngIf="admin.role =='CORPORATE_WELLNESS_CHAMPION'"
                                        class="text-capialize">{{lang.Wellness_Champion}}</span>
                                      <span *ngIf="admin.role == 'CORPORATE_OTHERS'"
                                        class="text-capitalize">{{ admin.roleName }}</span>
                                      <span *ngIf="
                                          admin.role !==
                                            'CORPORATE_ACCOUNTANT' &&
                                          admin.role !==
                                            'CORPORATE_EXECUTIVE' &&
                                          admin.role !==
                                            'CORPORATE_PLAN_ADMINISTRATOR' &&
                                          admin.role !== 'CORPORATE_ADMIN' &&
                                          admin.role !==
                                            'CORPORATE_WELLNESS_CHAMPION' &&
                                          admin.role !== 'CORPORATE_OTHERS'
                                        " class="text-capitalize">{{ admin.role }}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- {{lang.Group_Contacts}} -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"
                  *ngIf="groupContacts.length > 1 || groupContacts.length === 0">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Group_Contacts}}
                        <button class="addgroupadmininfoemp" (click)="basicModalOpen()" *ngIf="!formConfigLoading">
                          <strong>+&nbsp;{{lang.Add}}</strong>
                        </button>
                        <div class="is-loading col-3" *ngIf="formConfigLoading">
                          <p></p>
                        </div>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="groupContacts.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let admin of groupContacts;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/Group_contacts.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body py-2 px-1 groupContactsBgClr tileheight">
                                      <div class="ms-2">
                                        <div style="
                                            float: right;
                                            text-align: right;
                                            display: flex;
                                            margin-top: 0px;
                                          " class="ftsize16">
                                          &nbsp;&nbsp;
                                          <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                            data-bs-target="#basicModaledit" (click)="editadmin(admin, i)" style="
                                              color: #1429a9;
                                              cursor: pointer;
                                            " title="Edit"></i>
                                          &nbsp;&nbsp;
                                          <i class="bi bi-trash-fill redClr" (click)="deleteadmin(admin, i)"
                                            style="color: red; cursor: pointer" title="Delete"></i>
                                        </div>

                                        <div class="mt-2">
                                          <img src="./../assets/img/planholder.svg" alt class="widHigSvgIcon"
                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Name" /><span
                                            class="ms-2">{{ admin.firstName }}
                                            {{ admin.lastName }}</span>
                                        </div>

                                        <div class="mt-2" *ngIf="admin.phoneNum">
                                          <img src="./../assets/img/mobile.svg" alt class="widHigSvgIcon"
                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Phone" />
                                          <span class="ms-2">{{
                                            admin.phoneNum
                                            }}</span>
                                        </div>
                                        <div class="mt-2 d-flex">
                                          <img src="./../assets/img/email.svg" alt class="widHigSvgIcon"
                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Email" />
                                          <span title="{{ admin?.email }}" class="ms-2 email-truncate" *ngIf="showMaskedAdminMail"
                                            style="cursor: pointer">
                                            <!-- {{
                                            admin.email.length > 24
                                            ? admin.email.slice(0, 6) +
                                            "..." +
                                            admin.email.slice(-6)
                                            : admin.email
                                            }} -->
                                            <!-- {{admin.email}} -->
                                              
    <a
      href="javascript:void(0)"
      (click)="copyToClipboard2(employee.email)"
      style="text-decoration: underline; color: blue; cursor: pointer; font-size: 12px;"
      title="Click to copy">
      {{ admin.email }}
    </a>
  

                                            <!-- <span *ngIf="admin.emailClicked">{{
                                              admin.email
                                              }}</span>
                                            <span *ngIf="!admin.emailClicked">{{
                                              admin.maskedEmail ?? admin.email
                                              }}</span> -->

                                          </span>
                                        </div>
                                        <div class="mt-2">
                                          <img src="./../assets/img/RoleImage.png" alt class="widHigSvgIcon"
                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Role" />
                                          <span class="ms-2">
                                            <span *ngIf="admin.role =='CORPORATE_ACCOUNTANT'"
                                              class="text-capitalize">{{lang.Accountant}}</span>
                                            <span *ngIf="admin.role =='CORPORATE_EXECUTIVE'"
                                              class="text-capitalize">Executive</span>
                                            <span *ngIf="admin.role =='CORPORATE_PLAN_ADMINISTRATOR'"
                                              class="text-capitalize">{{lang.Plan_Administrator}}</span>
                                            <span *ngIf="admin.role == 'CORPORATE_ADMIN'"
                                              class="text-capitalize">{{lang.System_Administrator}}</span>
                                            <span *ngIf="admin.role =='CORPORATE_WELLNESS_CHAMPION'"
                                              class="text-capitalize">{{lang.Wellness_Champion}}</span>
                                            <span *ngIf="admin.role == 'CORPORATE_OTHERS'"
                                              class="text-capitalize">{{ admin.roleName }}</span>
                                            <span *ngIf="
                                                admin.role !==
                                                  'CORPORATE_ACCOUNTANT' &&
                                                admin.role !==
                                                  'CORPORATE_EXECUTIVE' &&
                                                admin.role !==
                                                  'CORPORATE_PLAN_ADMINISTRATOR' &&
                                                admin.role !==
                                                  'CORPORATE_ADMIN' &&
                                                admin.role !==
                                                  'CORPORATE_WELLNESS_CHAMPION' &&
                                                admin.role !==
                                                  'CORPORATE_OTHERS'
                                              " class="text-capitalize">{{ admin.role }}</span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" (click)="leftClick()" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" (click)="rightClick()" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="groupContacts.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment method -->

                <div *ngIf="roeAgreementSigned" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Payment_method}}</span>
                    </div>
                    <div class="_card_body payment_card">
                      <div class="_card_body_image">
                        <span class="imgHeaderLabel">{{
                          paymentMethodHeader
                          }}</span>
                        <img
                          src="https://testcustomersapi.groupbenefitz.aitestpro.com/api/ep/app/resources/images/dashboard/payment-method.png" />
                      </div>
                      <div class="_card_body_body" style="position: relative;">
                        <div class="text-center">
                          <div class="row mt-2" style="margin-left: 0px" *ngIf="
                              paymentMethodHeader ==
                              'Pre-Authorized Debit (PAD)' && bankId != ''
                            ">
                            <div class="col-4 text-start ftsize12">
                              {{lang.Bank_Id}}:
                              <div>
                                {{ bankId }}
                              </div>
                            </div>
                            <div class="col-4 text-start ftsize12">
                              {{lang.Transit}}:
                              <div>
                                {{ transit }}
                              </div>
                            </div>
                            <div class="col-4 text-start ftsize12">
                              {{lang.A_c_No}}:
                              <div>
                                {{ account }}
                              </div>
                            </div>
                            <div class="col-12 text-start ftsize12">
                              {{lang.Bank_Details}}:
                              <div>
                                {{ bankNameNdAddress }}
                              </div>
                            </div>
                          </div>

                          <div class="mt-2 row ftsize12" style="margin-left: 0px"
                            *ngIf="paymentMethodHeader == 'Credit Card' && ccDetails?.length > 0">
                            <div class="col-6 text-start mb-1">{{ lang?.Card_holder_name }}</div>
                            <div class="col-6 text-start p-0">{{ ccFirstName +" "+ ccLastName }}</div>
                            <div class="col-6 text-start mb-1">{{ lang.Card_Number }}</div>
                            <div class="col-6 text-start p-0">{{ creditcardNumber }}</div>
                            <div class="col-6 text-start mb-1">{{ lang.Expiry }}</div>
                            <div class="col-6 text-start p-0"
                              [style.color]="ccExpiryColor"
                              data-bs-toggle="tooltip"
                              title="{{ ccExpiryTitle }}"
                              data-bs-placement="top"
                            >
                              <span *ngIf="ccExpiryColor == 'red'" class="blinker"></span>
                              {{ cardExpiry ? cardExpiry : "" }}
                            </div>
                          </div>
                        </div>

                        <div style="position: absolute; margin-top:0px; width: 100%">
                          <div style="display: flex;justify-content: end;padding-right: 10px;">
                            <button
                              id="viewButton"
                              *ngIf="isReauth===true"
                              class="btn btn-sm btn-light"
                              style="border: 1px solid rgb(20, 42, 73);"
                              (click)="reAuthorize()"
                            >
                              Re-authorize
                            </button>
                            <button
                              id="viewButton"
                              *ngIf="isRetryPayment===true"
                              class="btn btn-sm btn-light"
                              style="border: 1px solid rgb(20, 42, 73);"
                              (click)="retryPayment()"
                            >
                              Retry Payment
                            </button>
                          </div>

                          <div class="mt-2 row ftsize12" style="margin-left: 0px"
                            *ngIf="true">
                            <!-- <div style="font-size: 12px">
                              Missing Payment Method
                            </div> -->
                            <p class="col-1" style="margin: 0px; padding: 0px">
                              &nbsp;<i
                                class="fa fa-send-o"
                                style="color: balck; cursor: pointer"
                                data-bs-toggle="modal"
                                data-bs-target="#emailConfirmationModal"
                                (click)="getInviteEmails()"
                              >
                              </i
                              >&nbsp;
                            </p>
                            <p
                              class="col-10 ps-1"
                              style="font-size: 12px; margin: 0px; padding: 0px"
                            >
                              *{{lang?.Invite}}
                              <b>
                                {{ groupContacts[0]?.firstName | titlecase }}
                                {{ groupContacts[0]?.lastName | titlecase }}</b
                              >
                              {{lang?.to_update_payment_method}}
                            </p>
                          </div>
                        </div>

                      </div>
                      <div class="_card_body_footer">
                        <div>
                          <p class="ftsize8" style="font-weight: bold; margin-top: 15px">
                            {{lang.Note}}:
                          </p>
                          <p class="ftsize8" style="margin-top: -15px">
                            {{lang.Please_update_the_payment_method_in_the_corporate_dashboard}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Corporate proposal status -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Corporate_Proposal_Status}}</span>
                    </div>
                    <div class="_card_body proposal_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/Proposal_Progress.png" />
                      </div>
                      <div class="_card_body_body py-2" style="padding-left:10px;">
                        <table border="0" class="table border-0 bg-transparent">
                         <tbody>
    <tr *ngIf="!!registeredDate && registeredDate?.trim() !== 'NA' && registeredDate?.trim() !== ''">
      <td>{{ lang.Proposal_received_on }}</td>
      <td>
        {{ moments(registeredDate).format(dateFormat) }}
      </td>
    </tr>

    <tr>
      <td>{{ lang.Status }}</td>
      <td class="text-wrap">
        {{ registeredDate?.trim() !== '' ? 'Enrollment Completed' : 'Enrollment Pending' }}
      </td>
    </tr>

    <tr>
      <td>{{ lang.Amendments }}</td>
      <td>{{ Amendment }}</td>
    </tr>
  </tbody>
                        </table>
                      </div>
                      <!-- <div class = "_card_body_footer">
                </div> -->
                    </div>
                  </div>
                </div>

                <!-- Enrollment Summary card box -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Enrollment_Summary}}</span>
                    </div>
                    <div class="_card_body enroll_card">
                      <div class="_card_body_image">
                        <img src="./../assets/img/enrollment_summary.png" />
                      </div>
                      <div class="_card_body_body py-2">
                        <table border="0" class="table border-0 bg-transparent">
                          <tbody class="d-inline">
                            <tr>
                              <td>{{lang.Employees_invited_to_Enroll}}</td>
                              <td>{{ invitationSentCount }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Enrolled}}</td>
                              <td>{{ enrolldCount }}</td>
                            </tr>
                            <tr>
                              <td>{{lang.Cancelled}}</td>
                              <td>{{ invitationPendingCount }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"></div>
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"></div>
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"></div>
              </div>

              <div class="mb-5"></div>

              <!-- {{lang.Corporate_Information}} -->
              <!-- <div class="row">
                <div class="ftsize12 mt-2">
                  <div class="card paymentCard p-0">
                    <div class="card-header ftsize12">
                      <a class>Corporate
                        Information&nbsp;&nbsp;<i
                          class="bi bi-info-circle"></i></a>
                    </div>
                    <div class="card-body ftsize12 ">
                      <div class="row">
                        <div class="col-sm-12">

                          <form class="onbordingform"
                            [formGroup]="clientregform">
                            <div class="row">

                            </div>
                            <div class="input-wrapper row">
                              <div class="form-group col-12 col-md-6">
                                <label for="Corporation"
                                  class="Corporation">Name of
                                  Corporation<span
                                    style="color: red">*</span></label>
                                <input type="text"
                                  class="form-control checking-field"
                                  id="nameofcorporation"
                                  placeholder="{{lang.Name_of_Corporation}}"
                                  formControlName="corporationName"
                                  [(ngModel)]="CorpName"
                                  (blur)="checkNameExists()" />
                                <div
                                  *ngIf="client['corporationName'].touched && client['corporationName'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please
                                    enter corporation name</div>
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">
                                    Corporation name should be 3
                                    characters</div>
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">
                                    Corporation name must not exceed 70
                                    characters</div>
                                  <div
                                    *ngIf="client['corporationName'].errors &&client['corporationName'].errors['pattern']">
                                    Corporation name Shouldn't allow numbers,
                                    special
                                    characters and blank spaces
                                  </div>
                                </div>

                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Policy Start
                                  Date<span style="color: red">*</span></label>

                                <select class="form-control ftsize"
                                  id="planenrollmentdate"
                                  placeholder="Select"
                                  formControlName="PolicyStartDate"
                                  [(ngModel)]="policyStartDate">
                                  <option value label>Select</option>
                                  <option *ngFor="let name of enrollmentDates"
                                    [value]="name"
                                    [label]="name">
                                    {{ name }}
                                  </option>
                                </select>
                                <div
                                  *ngIf="client['PolicyStartDate'].touched && client['PolicyStartDate'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['PolicyStartDate'].errors && client['PolicyStartDate'].errors['required']">Please
                                    choose policy start date</div>
                                </div>
                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="multiSelectProviance"
                                  class="Corporation">Provincial offices in
                                  Operation<span
                                    style="color: red">*</span></label>
                                <div class style="margin-top: -5px;">
                                  <ng-multiselect-dropdown class="ftsize"
                                    formControlName="multiSelectProviance"
                                    [placeholder]="'Select'"
                                    [settings]="dropdownSettings"
                                    [data]="configprovincereslist1"
                                    (onSelect)="multiSelectProvianceItemSelect($event)"
                                    (onSelectAll)="multiSelectProvianceSelectAll($event)"
                                    (onDeSelect)="multiSelectProvianceItemDeSelect($event)"
                                    (onDeSelectAll)="multiSelectProvianceItemDeSelectAll($event)"
                                    style="background-color: rgb(232, 234, 240);">
                                  </ng-multiselect-dropdown>
                                </div>
                                <div
                                  *ngIf="client['multiSelectProviance'].touched"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['multiSelectProviance'].errors &&
               client['multiSelectProviance'].errors['required']">
                                   {{lang.Please_select_province}}
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="row">
                              <div class="form-group col-12 col-md-6">
                                <label for="Corporation"
                                  class="Corporation">Street
                                  Address<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="Street Address"
                                  placeholder="Street Address"
                                  style="text-transform: capitalize;"
                                  formControlName="streetAddress"
                                  [(ngModel)]="streetAddress" />
                                <div
                                  *ngIf="client['streetAddress'].touched && client['streetAddress'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['streetAddress'].errors && client['streetAddress'].errors['required']">Please
                                    enter street address</div>
                                </div>
                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Street Address
                                  Line 2</label>

                                <input type="text"
                                  class="form-control checking-field"
                                  style="text-transform: capitalize;"
                                  id="StreetAddreess2"
                                  placeholder="Street Address Line 2"
                                  [(ngModel)]="streetAddress2"
                                  formControlName="streetAddress2" />

                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Unit/Apt/Suite
                                  #</label>

                                <input type="text"
                                  class="form-control checking-field"
                                  style="text-transform: capitalize;" id="apt"
                                  placeholder="Unit/Apt/Suite #"
                                  [(ngModel)]="apt"
                                  formControlName="apt" />
                                <div
                                  *ngIf="client['apt'].touched && client['apt'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['apt'].errors && client['apt'].errors['aptexpression']">Please
                                    enter
                                    valid Unit/Apt/Suite number</div>
                                  <div
                                    *ngIf="client['apt'].errors && client['apt'].errors['maxlength']">Unit/Apt/Suite
                                    name must not
                                    exceed 10 characters</div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">City<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="city" placeholder="City"
                                  style="text-transform: capitalize;"
                                  formControlName="city"
                                  [(ngModel)]="city" />
                                <div
                                  *ngIf="client['city'].touched && client['city'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['city'].errors && client['city'].errors['required']">Please
                                    enter city</div>
                                </div>

                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Country<span
                                    style="color: red">*</span></label>

                                <select class="form-control" id="country"
                                  placeholder="Country"
                                  formControlName="country"
                                  [(ngModel)]="country"
                                  (change)="getprovincelist($event)">
                                  <option value
                                    [disabled]="true">Select</option>
                                  <option *ngFor="let country of countryList"
                                    [value]="country.name">
                                    {{country.name}}
                                  </option>
                                </select>
                                <div
                                  *ngIf="client['country'].touched && client['country'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['country'].errors && client['country'].errors['required']">Please
                                    select country
                                  </div>
                                </div>

                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">{{stateLabel}}<span
                                    style="color: red">*</span></label>
                                <select class="form-control" id="Province"
                                  placeholder="Province"
                                  style="text-transform: capitalize;"
                                  formControlName="Province"
                                  (change)="provincelist($event.target.value)"
                                  [(ngModel)]="province">
                                  <option value>Select</option>

                                  <option
                                    *ngFor="let name of configprovincereslist"
                                    [value]="name.shortName">
                                    {{ name.shortName }}
                                  </option>
                                </select>

                                <div
                                  *ngIf="client['Province'].touched && client['Province'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['Province'].errors && client['Province'].errors['required']">Please
                                    select
                                    province</div>
                                </div>
                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">{{zipCodeLabel}}<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="postalcode" placeholder="{{zipCodeLabel}}"
                                  onkeyup="this.value = this.value.toUpperCase();"
                                  formControlName="postalCode"
                                  [(ngModel)]="postalCode"
                                  (input)="changeTextToUppercase('postalcode', $event)" />
                                <div *ngIf="client['postalCode'].touched"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['postalCode'].errors && client['postalCode'].errors['required']">Please
                                    enter
                                    {{zipCodeLabel}}</div>
                                  <div
                                    *ngIf="invalidpostalcodeprivince || client['postalCode'].touched &&client['postalCode'].hasError('invalidPostalCode')">
                                    Please enter valid {{zipCodeLabel}}</div>

                                </div>

                              </div>

                            </div>
                            <div class="row">
                              <div>
                                <button type="submit"
                                  class="btn btn-primary ftsize addgroupadmininfoemp"
                                  (click)="updateCorporateAddress()"><b>
                                    Update</b></button>
                              </div>
                            </div>
                          </form>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div> -->

              <!-- {{lang.Group_Contacts}} start -->
              <!-- <div class="row">
                <div class="ftsize12 mt-2">
                  <div class="card paymentCard p-0">
                    <div class="card-header ftsize12">
                      {{lang.Group_Contacts}} <button class="addgroupadmininfoemp"
                        (click)="basicModalOpen()"><strong>+&nbsp;Add
                          More</strong></button>
                    </div>
                    <div class="card-body ftsize12 ">
                      <div class="row">
                        <div class="col-sm-12">
                          <form class="plansform">
                            <div class="row">

                              <div class="row groupContactstileheight">
                                <div class="form-group col-12">
                                  <div
                                    style="overflow: auto; direction:ltr;  width: 100%;">
                                    <table align="left">
                                      <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Phone Number</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th></th>
                                      </tr>
                                      <tbody>
                                        <tr
                                          *ngFor="let admin of groupContacts; let i = index"
                                          [ngClass]="{'orange': i % 2 == 0, 'white': i % 2 != 0}">
                                          <td
                                            class="borderclr">{{admin.firstName}}</td>
                                          <td
                                            class="borderclr">{{admin.lastName}}</td>
                                          <td
                                            class="borderclr">{{admin.phoneNum}}</td>
                                          <td
                                            class="borderclr">{{admin.email}}</td>
                                          <td class="borderclr">
                                            <span
                                              *ngIf="admin.role=='CORPORATE_ACCOUNTANT'">{{lang.Accountant}}</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_EXECUTIVE'">Executive</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_PLAN_ADMINISTRATOR'">Plan
                                              Administrator</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_ADMIN'">System
                                              Administrator</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_WELLNESS_CHAMPION'">Wellness
                                              Champion</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_OTHERS'">{{
                                              admin.roleName }}</span>
                                            <span *ngIf="
                              admin.role !== 'CORPORATE_ACCOUNTANT' &&
                              admin.role !== 'CORPORATE_EXECUTIVE' &&
                              admin.role !== 'CORPORATE_PLAN_ADMINISTRATOR' &&
                              admin.role !== 'CORPORATE_ADMIN' &&
                              admin.role !== 'CORPORATE_WELLNESS_CHAMPION' &&
                              admin.role !== 'CORPORATE_OTHERS'">{{ admin.role
                                              }}</span>
                                          </td>
                                          <td
                                            style="text-align:right;display:flex; margin-top:0px;"
                                            class="borderclr">
                                            &nbsp;&nbsp;
                                            <i class="bi bi-pencil-square"
                                              data-bs-toggle="modal"
                                              data-bs-target="#basicModaledit"
                                              (click)="editadmin(admin,i)"
                                              style="color:#1429A9; cursor: pointer;"
                                              title="Edit"></i>
                                            &nbsp;&nbsp;
                                            <i class="bi bi-trash-fill redClr"
                                              (click)="deleteadmin(admin,i)"
                                              style="color:red; cursor: pointer"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Delete"></i>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div> -->
              <!-- end {{lang.Group_Contacts}} -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</main>

<!-- *********************************Start Corp info popups -->
<!-- Add {{lang.Group_Contacts}} -->

<div class="modal fade" id="settingsEdit" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" style="width: 1000px">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_settings}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="settingsform">
          <div class="row">
            <div class="form-group col-md-12">
              <h6 class="admintitle">
                {{lang.Enrollment_start_date_for_new_hires}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>
            </div>
            <div class="row mt-1">
              <div class="form-group col-5">
                <div class="label waitingperiod">
                  <b>{{lang.Waiting_Period_for_new_hires}}</b>
                </div>

                <div class="d-flex gap-1 flex-shrink-0">
                  <div class="d-flex">
                    <input type="radio" class="" name="waitingPeriod" formControlName="waitingPeriod"
                      id="nowaitingPeriod" [value]="0" (change)="waitingPeriodChange($event)" />&nbsp;<label
                      for="nowaiting" class="form-check-label pe-1 my-auto">{{lang.None}}</label>
                  </div>

                  <div class="d-flex">
                    <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod" id="threemonths"
                      [value]="3" (change)="waitingPeriodChange($event)" />&nbsp;<label for="threemonths"
                      class="form-check-label pe-1 my-auto">{{lang.Three_Months}}</label>
                  </div>
                  <div class="d-flex">
                    <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod" id="sixmonths"
                      [value]="6" (change)="waitingPeriodChange($event)" />&nbsp;<label for="sixmonths"
                      class="form-check-label pe-1 my-auto">{{lang.Six_Months}}</label>
                  </div>
                  <div class="d-flex">
                    <input type="radio" name="waitingPeriod" class="" formControlName="waitingPeriod"
                      id="customselection" value="Custom" (change)="waitingPeriodChange($event)" />&nbsp;<label
                      for="customselection" class="form-check-label pe-1 my-auto">{{lang.Custom}}</label>
                  </div>
                </div>

                <div class="form-group col-3 ps-0 pe-0 mt-0 mb-0">
                  <div *ngIf="customSelected">
                    <label for="customMonths" class="">Months<span style="color: red">*</span></label>
                    <input type="text" class="form-control" (keypress)="numberOnly($event)" id="customMonths"
                      [(ngModel)]="waitTime" formControlName="waitingPeriodCustom" />&nbsp;
                  </div>
                  <span class="help-block text-danger" *ngIf="
                      settingsform.get('waitingPeriodCustom').touched &&
                      customSelected &&
                      (settingsform.get('waitingPeriodCustom').value ==
                        undefined ||
                        settingsform.get('waitingPeriodCustom').value == '')
                    ">
                    {{lang.Please_enter_months}}
                  </span>
                </div>
              </div>

              <div class="form-group col-5">
                <div class="label waitingperiod" style="margin-bottom: 15px">
                  <!-- <b>{{lang.Waiting_period_for_Employees_on_initial_sign_up}}</b> -->
                  <b>Waiting period for Employees on initial enrollment</b>

                  <br />
                  <div class="row mt-1">
                    <div class="form-check col-3">
                      <input type="radio" name="waitingPeriodinitialsignup" id="waitingPeriodinitialsignupNo"
                        [value]="false" formControlName="waitingPeriodinitialsignup" />
                      <label for="waitingPeriodinitialsignupNo"
                        class="walletConfig my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                    </div>
                    <div class="form-check col-3">
                      <input type="radio" name="waitingPeriodinitialsignup" id="waitingPeriodinitialsignupYes"
                        [value]="true" formControlName="waitingPeriodinitialsignup" />
                      <label for="waitingPeriodinitialsignupYes"
                        class="walletConfig my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                    </div>
                    <div *ngIf="
                        settings['waitingPeriodinitialsignup'].touched &&
                        settings['waitingPeriodinitialsignup'].invalid
                      " class="help-block text-danger">
                      <div *ngIf="
                          settings['waitingPeriodinitialsignup'].errors &&
                          settings['waitingPeriodinitialsignup'].errors[
                            'required'
                          ]
                        ">
                        <!-- {{lang.Please_Select_waiting_period_for_employees_on_initial_Signup}} -->
                        Please Select waiting period for employees on initial enrollment
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-12 col-md-5">
              <div class="form-group">
                <h6 class="admintitle">
                  {{lang.Payment_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>

                <div class="form-check ps-0 d-flex">
                  <input class="" type="radio" id="creditpaymentInfo" name="paymentInfo" formControlName="paymentInfo"
                    value="creditcard" (click)="checkPaymentInfo($event)"
                    [checked]="paymentMethod == 'CREDIT_CARD' && true" />
                  <label class="form-check-label ps-1 my-auto" for="flexRadioDefault1">
                    {{lang.Credit_Card}}
                  </label>
                </div>
                <!-- <div class="form-check ps-0 d-flex">
                  <input class="" type="radio" id="padcreditpaymentInfo" name="paymentInfo"
                    formControlName="paymentInfo" value="pad" [checked]="paymentMethod != 'CREDIT_CARD' && true"
                    (click)="checkPaymentInfo($event)" />
                  <label class="form-check-label ps-1 my-auto" for="flexRadioDefault2">
                    {{lang.Pre_Authorized_Debit}}
                  </label>
                </div> -->
                <div class="form-check ps-0 d-flex">
                  <input class="" type="radio" id="padcreditpaymentInfo" name="paymentInfo"
                    formControlName="paymentInfo" value="pad" [checked]="paymentMethod == 'ACH' && true"
                    (click)="checkPaymentInfo($event)" />
                  <label class="form-check-label ps-1 my-auto" for="flexRadioDefault2">
                    {{ lang.Pre_Authorized_Debit }}
                  </label>
                </div>
                <div class="form-check d-flex">
                  <input class="form-check-input" type="radio" name="paymentInfo" id="invoicepaymentInfo"
                    formControlName="paymentInfo" value="invoicemonthy" (click)="checkPaymentInfo($event)"
                    *ngIf="role == 'CORPORATE_ADMIN'" />
                  <label class="form-check-label my-auto" for="flexRadioDefault3" *ngIf="role == 'CORPORATE_ADMIN'">
                    Invoice Monthly
                  </label>
                </div>
                <div *ngIf="
                    settings['paymentInfo'].touched &&
                    settings['paymentInfo'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      settings['paymentInfo'].errors &&
                      settings['paymentInfo'].errors['required']
                    ">
                    {{lang.Please_select_payment_information}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-5">
              <div class="form-group">
                <h6 class="admintitle mb-2">{{lang.No_of_Employees}}</h6>

                <input type="text" class="form-control text-center" formControlName="expectednoofEmployees"
                  (keypress)="numberOnly($event)" (paste)="onPaste($event)" [(ngModel)]="noOfEmployees" />
                <div *ngIf="
                    settings['expectednoofEmployees'].touched &&
                    settings['expectednoofEmployees'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      settings['expectednoofEmployees'].errors &&
                      settings['expectednoofEmployees'].errors['required']
                    ">
                    {{lang.Please_enter_no_of_employees}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-5">
              <div class="form-group">
                <h6 class="admintitle">
                  <!-- {{lang.Show_Employer_Name_for_Signups}}&nbsp;&nbsp; -->
                  Show Employer Name for Enrollments&nbsp;&nbsp;
                </h6>

                <div class="row">
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="ShowEmployer" id="ShowEmployerYes" [value]="true"
                      formControlName="ShowEmployer" [(ngModel)]="requireEmpName" [checked]="requireEmpName === true" />
                    <label for="ShowEmployerYes" class="walletConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                  </div>
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="ShowEmployer" id="ShowEmployerNo" [value]="false"
                      formControlName="ShowEmployer" [(ngModel)]="requireEmpName"
                      [checked]="requireEmpName === false" />
                    <label for="ShowEmployerNo" class="walletConfig">&nbsp;&nbsp;{{lang.No}}</label>
                  </div>

                  <div *ngIf="
                      settings['ShowEmployer'].touched &&
                      settings['ShowEmployer'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        settings['ShowEmployer'].errors &&
                        settings['ShowEmployer'].errors['required']
                      ">
                      {{lang.Please_select_wallet_configuration}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5" *ngIf="role === 'ADMINISTRATOR'">
              <div class="form-group">
                <h6 class="admintitle">
                  {{lang.Auto_select_plans_for_Employee}}&nbsp;&nbsp;
                </h6>
                <div class="row">
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="autoSelectEmp" id="tierConfigyes" [value]="true"
                      formControlName="autoSelectEmp" />
                    <label for="autoSelectEmpYes" class="tierConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                  </div>
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="autoSelectEmp" id="tierConfigno" [value]="false"
                      formControlName="autoSelectEmp" />
                    <label for="autoSelectEmpno" class="tierConfig">&nbsp;&nbsp;{{lang.No}}</label>
                  </div>
                  <div *ngIf="
                      settings['autoSelectEmp'].touched &&
                      settings['autoSelectEmp'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        settings['autoSelectEmp'].errors &&
                        settings['autoSelectEmp'].errors['required']
                      ">
                      {{lang.Please_Select}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5" *ngIf="role === 'ADMINISTRATOR'">
              <div class="form-group">
                <h6 class="admintitle">
                  {{lang.GroupBenefitz_WalletTM_for_employees}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>

                <div class="row">
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="walletConfig" id="walletconfigyes" [value]="true"
                      formControlName="walletConfig" [(ngModel)]="setupWallet" [checked]="setupWallet === true" />
                    <label for="walletconfigyes" class="walletConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                  </div>
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="walletConfig" id="walletconfigyno" [value]="false"
                      formControlName="walletConfig" [(ngModel)]="setupWallet" [checked]="setupWallet === false" />
                    <label for="walletconfigyno" class="walletConfig">&nbsp;&nbsp;{{lang.No}}</label>
                  </div>

                  <div *ngIf="
                      settings['walletConfig'].touched &&
                      settings['walletConfig'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        settings['walletConfig'].errors &&
                        settings['walletConfig'].errors['required']
                      ">
                      {{lang.Please_select_wallet_configuration}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="form-group">
                <h6 class="admintitle">
                  {{lang.Create_classification_tiers_of_coverage}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>
                <div class="row">
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="tierConfig" id="tierConfigyes" [value]="true" formControlName="tierConfig"
                      [(ngModel)]="setUplevelofCoverage" [checked]="setUplevelofCoverage === true" />
                    <label for="tierConfigyes" class="tierConfig">&nbsp;&nbsp;{{lang.Yes}}</label>
                  </div>
                  <div class="form-check col-12 col-md-3">
                    <input type="radio" name="tierConfig" id="tierConfigno" [value]="false" formControlName="tierConfig"
                      [(ngModel)]="setUplevelofCoverage" [checked]="setUplevelofCoverage === false" />
                    <label for="tierConfigno" class="tierConfig">&nbsp;&nbsp;{{lang.No}}</label>
                  </div>
                  <div *ngIf="
                      settings['tierConfig'].touched &&
                      settings['tierConfig'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        settings['tierConfig'].errors &&
                        settings['tierConfig'].errors['required']
                      ">
                      {{lang.Please_select_tier_configuration}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="settingsform.invalid"
          (click)="updateSettings()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="basicModal1" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder={{lang.First_Name}}
                formControlName="adminfirstname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  {{lang.First_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname" placeholder={{lang.Last_Name}}
                formControlName="adminlastname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  {{lang.Last_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Phone_Number}}<span
                  style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  {{lang.Please_enter_Phone_Number}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['minlength']">Phone number must be minimum of 10 digits</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="adminemail"   (input)="forceLowercase($event)"/>
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Role}}<span style="color: red">*</span></label>

              <!-- <select class="form-control" id="lengthofService" formControlName="role">
                <option value="" disabled>Select</option>
                <option value="ADMINISTRATOR">System Administrator</option>
                <option value="CORPORATE_ACCOUNTANT">Accountant</option>
                <option value="CORPORATE_EXECUTIVE">Executive</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">Plan Administrator</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">Wellness Champion</option>
                <option value="CORPORATE_OTHERS">Other</option>
              </select> -->
              <select class="form-control ftsize14" id="lengthofService" formControlName="role" (click)="roleOthers()">
                <option value disabled>{{lang.Select}}</option>
                <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  {{lang.Plan_Administrator}}
                </option>
                <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                <option value="CORPORATE_ADMIN">{{lang.System_Administrator}}</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  {{lang.Wellness_Champion}}
                </option>
                <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  {{lang.Please_select_Role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="roleOthers()">
              <label for class="Corporation2">{{lang.Others}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lengthofServiced" placeholder
                formControlName="roleOther" [(ngModal)]="editadminroleothers" />
              <div *ngIf="f['roleOther'].touched && f['roleOther'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['roleOther'].errors && f['roleOther'].errors['required']
                  ">
                  {{lang.Please_enter_role_name}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="adminform.invalid"
          (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div id="roeAgreement" class="modal fade viewModal" role="dialog" aria-labelledby="modal-label" style="display: none"
  data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.ROE_Agreement}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-4">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" 
          style="padding-right:10px;"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <pdf-viewer *ngIf="true" id="pdf-viewer" [src]="employeeRoeURL" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
      <!-- <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton" (click)="closepadinfo()"><b>{{lang.close_cp}}</b></button>
          </div> -->
    </div>
  </div>
</div>

<div id="viewRoe-employees" class="modal fade viewModal" role="dialog" aria-labelledby="modal-label"
  style="display: none" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-sm modal-dialog-centered" id="heightWidthModal3">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.View_ROEs}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-4">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <table class="table table-bordered" style="white-space: nowrap">
          <thead>
            <tr>
              <!-- <th>S.no</th> -->
              <th>{{lang.Document}}</th>
              <th>{{lang.Action}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let roe of employeeRoe; let i = index">
              <!-- <td>{{ i + 1 }}</td> -->
              <td>{{ roe.time }}</td>
              <td style="text-align: center">
                <span class>
                  <img src="/assets/img/view2.png" class="viewDownloadIcon cursor-pointer" role="button"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="View" (click)="getROEDetails(roe)" />
                  <img src="/assets/img/download2.png" class="viewDownloadIcon cursor-pointer ms-1" role="button"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Download"
                    (click)="DownloadROEContract2(roe.link)" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>

      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div id="videoform" class="modal fade modal-lg modalposition" tabindex="-1" role="dialog"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content1">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{ videoTitle }}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="video-modal-body">
        <video controls (canplay)="pauseVideo(videoplayer)" #videoPlayer>
          <source src="{{ videoLink }}" type="video/mp4" />

          {{lang.Your_browser_does_not_support_the_video_tag}}
        </video>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="iframeform">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{ iframeTitle }}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body">
        <!-- <iframe src="{{iframeLink | }}"></iframe> -->
        <iframe width="100%" *ngIf="iframeLink" [src]="iframeLink??''" id="pdf-viewer"></iframe>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal-lg modalposition" data-bs-backdrop="static" id="equitable">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.View_Your_Plan_Benefits}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body">
        <pdf-viewer *ngIf="true" id="pdf-viewer" [src]="booklet_link" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>


<div id="updateCorpInfo2" class="modal fade modal-lg" data-bs-backdrop="static">More actions
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" id="modal-content ">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Update_Corporate_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <form class [formGroup]="clientregform">
              <div class="row"></div>
              <div class="input-wrapper row">
                <div class="form-group col-12 col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Name_of_Corporation}}<span
                      style="color: red">*</span></label>
                  <!-- [(ngModel)]="CorpName" -->
                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    placeholder={{lang.Name_of_Corporation}} formControlName="corporationName" [value]="CorpName" />
                  <!-- (blur)="checkNameExists()" /> -->
                  <div *ngIf="
                      client['corporationName'].touched &&
                      client['corporationName'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['required']
                      ">
                      {{lang.Please_enter_corporation_name}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['minlength']
                      ">
                      {{lang.Corporation_name_should_be_3_characters}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['maxlength']
                      ">
                      {{lang.Corporation_name_must_not_exceed_70_characters}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['pattern']
                      ">
                      {{lang.Corporation_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Policy_Start_Date}}<span
                      style="color: red">*</span></label>

                  <select class="form-control ftsize" id="planenrollmentdate" placeholder="Select" disabled
                    formControlName="PolicyStartDate" [(ngModel)]="policyStartDate">
                    <option value label>{{lang.Select}}</option>
                    <option *ngFor="let name of enrollmentDates" [value]="name" [label]="name">
                      {{ name }}
                    </option>
                  </select>
                  <div *ngIf="
                      client['PolicyStartDate'].touched &&
                      client['PolicyStartDate'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['PolicyStartDate'].errors &&
                        client['PolicyStartDate'].errors['required']
                      ">
                      {{lang.Please_choose_policy_start_date}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="multiSelectProviance" class="Corporation">{{lang.Provincial_offices_in_Operation}}<span
                      style="color: red">*</span></label>
                  <div class style="margin-top: -5px">
                    <ng-multiselect-dropdown class="ftsize" formControlName="multiSelectProviance"
                      placeholder={{lang.Select}} [settings]="dropdownSettings" [data]="configprovincereslist1"
                      (onSelect)="multiSelectProvianceItemSelect($event)"
                      (onSelectAll)="multiSelectProvianceSelectAll($event)"
                      (onDeSelect)="multiSelectProvianceItemDeSelect($event)" (onDeSelectAll)="
                        multiSelectProvianceItemDeSelectAll($event)
                      " style="background-color: rgb(232, 234, 240)">
                    </ng-multiselect-dropdown>
                  </div>
                  <div *ngIf="client['multiSelectProviance'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['multiSelectProviance'].errors &&
                        client['multiSelectProviance'].errors['required']
                      ">
                      {{lang.Please_select_province}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12 col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span
                      style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="Street Address"
                    placeholder={{lang.Street_Address}} style="text-transform: capitalize"
                    formControlName="streetAddress" [(ngModel)]="streetAddress" />
                  <div *ngIf="
                      client['streetAddress'].touched &&
                      client['streetAddress'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['streetAddress'].errors &&
                        client['streetAddress'].errors['required']
                      ">
                      {{lang.Please_enter_street_address_name}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                  <input type="text" class="form-control checking-field" style="text-transform: capitalize"
                    id="StreetAddreess2" placeholder={{lang.Street_Address_Line_2}} [(ngModel)]="streetAddress2"
                    formControlName="streetAddress2" />
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Unit_Apt_Suite}}</label>

                  <input type="text" class="form-control checking-field" style="text-transform: capitalize" id="apt"
                    placeholder={{lang.Unit_Apt_Suite}} [(ngModel)]="apt" formControlName="apt" />
                  <div *ngIf="client['apt'].touched && client['apt'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        client['apt'].errors &&
                        client['apt'].errors['aptexpression']
                      ">
                      Please enter valid Unit/Apt/Suite number
                    </div>
                    <div *ngIf="
                        client['apt'].errors &&
                        client['apt'].errors['maxlength']
                      ">
                      Unit/Apt/Suite name must not exceed 10 characters
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                    style="text-transform: capitalize" formControlName="city" [(ngModel)]="city" />
                  <div *ngIf="client['city'].touched && client['city'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        client['city'].errors &&
                        client['city'].errors['required']
                      ">
                      {{lang.Please_enter_city_name}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                  <select class="form-control" id="country" placeholder="Country" formControlName="country"
                    [(ngModel)]="country" (change)="getprovincelist($event)">
                    <option value [disabled]="true">{{lang.Select}}</option>
                    <option *ngFor="let country of countryList" [value]="country.name">
                      {{ country.name }}
                    </option>
                  </select>
                  <div *ngIf="
                      client['country'].touched && client['country'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['country'].errors &&
                        client['country'].errors['required']
                      ">
                      {{lang.Please_select_country}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{ stateLabel }}<span style="color: red">*</span></label>
                  <select class="form-control" id="Province" placeholder="Province" style="text-transform: capitalize"
                    formControlName="Province" (change)="provincelist($event.target.value)" [(ngModel)]="province">
                    <option value>{{lang.Select}}</option>

                    <option *ngFor="let name of configprovincereslist" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="
                      client['Province'].touched && client['Province'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['Province'].errors &&
                        client['Province'].errors['required']
                      ">
                      {{lang.Please_select_province}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{ zipCodeLabel }}<span
                      style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="postalcode"
                    placeholder="{{ zipCodeLabel }}" onkeyup="this.value = this.value.toUpperCase();"
                    formControlName="postalCode" [(ngModel)]="postalCode"
                    (input)="changeTextToUppercase('postalcode', $event)" />
                  <div *ngIf="client['postalCode'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['postalCode'].errors &&
                        client['postalCode'].errors['required']
                      ">
                      Please enter {{ zipCodeLabel }}
                    </div>
                    <div *ngIf="
                        invalidpostalcodeprivince ||
                        (client['postalCode'].touched &&
                          client['postalCode'].hasError('invalidPostalCode'))
                      ">
                      Please enter valid {{ zipCodeLabel }}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div *ngIf="logo" class="uploadCorporateLogo form-group col-md-6">
                    <label style="float: right; color: red" title="Delete logo" (click)="removeExistingLogo($event)"><i
                        class="bi bi-trash-fill"></i></label>

                    <label for="adminlogo" class="adminlogo">
                      <img [src]="logo" style="max-height: 50px; width: 100%" />
                    </label>
                  </div>

                  <div *ngIf="!logo" class="uploadCorporateLogo form-group col-md-6">
                    <label style="float: right; color: red" title="Delete logo" *ngIf="uploadlogoafter"
                      (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill"></i></label>

                    <label for="adminlogo" class="adminlogo">
                      <span *ngIf="showimagelogo">
                        <p style="font-size: 10px">
                          {{lang.Click_to_upload_COMPANY_LOGO_Max_300x100_px_png_jpg}}
                        </p>
                      </span>
                      <img *ngIf="!showimagelogo" [src]="imagedisplay" style="max-height: 50px; width: 100%" />
                    </label>

                    <input id="adminlogo" type="file" accept="image/*" style="display: none"
                      formControlName="corporatelogo" (change)="uploadadminlogo($event)" />

                    <input id="adminlogo1" type="file" accept="image/*" style="display: none"
                      formControlName="corporatelogo" (change)="uploadadminlogo1($event)" />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
          {{lang.Close}}
        </button>

        <button type="submit" class="btn btn-primary" id="submitButton" [disabled]="
            clientregform.invalid ||
            clientregform.get('postalCode').hasError('invalidPostalCode')
          " (click)="updateCorporateAddress()">
          {{lang.Update}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="addEmployee" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Add_Employee}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder={{lang.First_Name}}
                formControlName="adminfirstname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  {{lang.First_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname" placeholder="Last Name"
                formControlName="adminlastname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  {{lang.Last_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Phone_Number}}<span
                  style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder="Phone"
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  {{lang.Please_enter_Phone_Number}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['minlength']">Phone number must be minimum of 10 digits</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder="Email"
                formControlName="adminemail" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Role}}<span style="color: red">*</span></label>

              <!-- <select class="form-control" id="lengthofService" formControlName="role">
                <option value="" disabled>Select</option>
                <option value="ADMINISTRATOR">System Administrator</option>
                <option value="CORPORATE_ACCOUNTANT">Accountant</option>
                <option value="CORPORATE_EXECUTIVE">Executive</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">Plan Administrator</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">Wellness Champion</option>
                <option value="CORPORATE_OTHERS">Other</option>
              </select> -->
              <select class="form-control ftsize14" id="lengthofService" formControlName="role" (click)="roleOthers()">
                <option value disabled>{{lang.Select}}</option>
                <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  {{lang.Plan_Administrator}}
                </option>
                <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                <option value="CORPORATE_ADMIN">{{lang.System_Administrator}}</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  {{lang.Wellness_Champion}}
                </option>
                <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  {{lang.Please_select_Role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="roleOthers()">
              <label for class="Corporation2">{{lang.Others}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lengthofServiced" placeholder={{lang.Others}}
                formControlName="roleOther" [(ngModal)]="editadminroleothers" />
              <div *ngIf="f['roleOther'].touched && f['roleOther'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['roleOther'].errors && f['roleOther'].errors['required']
                  ">
                  {{lang.Please_enter_role_name}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="adminform.invalid"
          (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Edit for Group contact_mail -->
<div class="modal fade" id="basicModaledit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="" [formGroup]="editadminform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder={{lang.First_Name}}
                formControlName="adminfirstname" [(ngModel)]="editadminfirstname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  fe['adminfirstname'].touched && fe['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    fe['adminfirstname'].errors &&
                    fe['adminfirstname'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    fe['adminfirstname'].errors &&
                    fe['adminfirstname'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    fe['adminfirstname'].errors &&
                    fe['adminfirstname'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    fe['adminfirstname'].errors &&
                    fe['adminfirstname'].errors['pattern']
                  ">
                  {{lang.First_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname" placeholder={{lang.Last_Name}}
                formControlName="adminlastname" [(ngModel)]="editadminlastname" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  fe['adminlastname'].touched && fe['adminlastname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    fe['adminlastname'].errors &&
                    fe['adminlastname'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    fe['adminlastname'].errors &&
                    fe['adminlastname'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    fe['adminlastname'].errors &&
                    fe['adminlastname'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
                <div *ngIf="
                    fe['adminlastname'].errors &&
                    fe['adminlastname'].errors['pattern']
                  ">
                  {{lang.Last_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Phone_Number}}<span
                  style="color: red">*</span></label>


              <input type="tel" class="form-control checking-field" id="adminphone" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" [(ngModel)]="editadminphone" (change)="editphoneFormat($event)"
                formControlName="adminphone" />

              <!-- <input type="text" class="form-control checking-field" id="adminphone" placeholder="Phone"
                (keypress)="numberOnly($event)"  (change)="phoneFormat($event)"(keypress)="numberOnly($event)" formControlName="adminphone"
                [(ngModel)]="editadminphone" /> -->

              <div *ngIf="fe['adminphone'].touched && fe['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    fe['adminphone'].errors &&
                    fe['adminphone'].errors['required']
                  ">
                  {{lang.Please_enter_Phone_Number}}
                </div>
                <div *ngIf="
                    fe['adminphone'].errors &&
                    fe['adminphone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    fe['adminphone'].errors &&
                    fe['adminphone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
                <!-- <div *ngIf="fe['adminphone'].errors && fe['adminphone'].errors['minlength']">Phone number must be minimum of 10 digits</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="adminemail" [(ngModel)]="editadminemail" />
              <div *ngIf="fe['adminemail'].touched && fe['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    fe['adminemail'].errors &&
                    fe['adminemail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    fe['adminemail'].errors &&
                    fe['adminemail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Role}}<span style="color: red">*</span></label>

              <select class="form-control ftsize14" id="lengthofService" formControlName="role" name="adminrole"
                [(ngModel)]="editadminrole" (click)="roleOthers()">
                <option value disabled>{{lang.Select}}</option>
                <!-- <option value="CORPORATE_ADMIN">Admin</option> -->
                <option value="CORPORATE_ACCOUNTANT">{{lang.Accountant}}</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  {{lang.Plan_Administrator}}
                </option>
                <option value="CORPORATE_ADMIN">{{lang.System_Administrator}}</option>
                <option value="CORPORATE_EXECUTIVE">{{lang.Executive}}</option>
                <option value="CORPORATE_WELLNESS_CHAMPION">
                  {{lang.Wellness_Champion}}
                </option>
                <option value="CORPORATE_OTHERS">{{lang.Others}}</option>
              </select>

              <div *ngIf="fe['role'].touched && fe['role'].invalid" class="help-block text-danger">
                <div *ngIf="fe['role'].errors && fe['role'].errors['required']">
                  {{lang.Please_select_Role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="roleOthers('edit')">
              <label for class="Corporation2">Others<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="lengthofServiced" placeholder
                formControlName="roleOther" [(ngModel)]="editadminroleothers" />
              <div *ngIf="fe['roleOther'].touched && fe['roleOther'].invalid" class="help-block text-danger">
                <div *ngIf="
                    fe['roleOther'].errors && fe['roleOther'].errors['required']
                  ">
                  {{lang.Please_enter_role_name}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" (click)="hidegrpadmindetails()"
          id="closeButton">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" (click)="editadminSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- delete modal -->
<div class="modal fade" id="basicModaldelete" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Confirm}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        {{lang.Are_you_sure_you_want_to_delete_this_contact}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" (click)="hidegrpadmindetails()"
          id="closeButton">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" (click)="deleteadmin()">
          {{lang.Delete}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- select payment method dialog -->
<!-- Added by sudeep.k on Apr 03 2024, if there is no payment method, showing the select payment method popup -->
<div class="modal viewModal" id="paymentInformation-modal1" role="dialog" aria-labelledby="modal-label"
  style="z-index: 1051 !important; display: none">
  <div class="modal-dialog modal-dialog-centered" id="heightWidthModal2" role="document">
    <div class="modal-content" style="position: relative" id="modal-content">
      <!-- <div class="modal-header">
        <span class="modal-title col-12 text-center">Payment Information</span>
        <span class="col-1">
          <button type="button" class="btn-close " data-bs-dismiss="modal"
            aria-label="Close" (click)="paymentInfoCancel()"></button>
        </span>
      </div> -->
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Payment_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="paymentInfoCancel()"></i>
        </div>
      </div>

      <div class="modal-body col-12 linescrollbar paymentModal_Body" style="overflow: scroll" id="Modall">
        <form class="paymentMethodForm mt-2" [formGroup]="paymentMethodForm" (ngSubmit)="paymentMethodSubmit()">
          <div class="row">
            <div class="row">
              <label for="form-label bankInfo2"> <b> {{lang.Payment_method}}:</b></label>
            </div>
            <div class="row">
              <div class="col-12 form-check form-check-inline">
                <input type="radio" name="paymentMethodSelection" id="paymentMethodSelection1"
                  formControlName="paymentMethodSelection" value="preAuthorizedDebit" class="border border-dark"
                  (change)="changePaymentSelection('preAuthorizedDebit')" />
                <label class="ms-1 bankInfo1 form-check-label">{{lang.Pre_Authorized_Debit}}</label>
              </div>
              <div class="col-12 form-check form-check-inline">
                <input type="radio" name="paymentMethodSelection" id="paymentMethodSelection2"
                  formControlName="paymentMethodSelection" value="creditCard" class="border border-dark"
                  (change)="changePaymentSelection('creditCard')" />
                <label class="ms-1 bankInfo1 form-check-label">{{lang.Credit_Card}}</label>
              </div>
            </div>
          </div>

          <!-- pad detail -->
          <form [formGroup]="padInformationForm" *ngIf="paymentMethodSelect">
            <div class="row mt-2">
              <div class="form-group col-4">
                <label class="Corporation">{{lang.Bank_Code}}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="bank Code" formControlName="bankCode"
                  placeholder="Bank Code" maxlength="3" (keypress)="numberOnly($event)" />
                <div *ngIf="
                    padPaymentControls['bankCode'].touched &&
                    padPaymentControls['bankCode'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['required']
                    ">{{lang.Please_enter_bank_code}}</span>
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['minlength']
                    ">{{lang.Bank_code_must_be_3_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['maxlength']
                    ">{{lang.Bank_code_must_be_3_digits}}</span>
                </div>
              </div>

              <div class="form-group col-4">
                <label class="Corporation">{{lang.Transit}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" formControlName="transit"
                  placeholder={{lang.Transit}} style="height: 30px" maxlength="5" (keypress)="numberOnly($event)" />

                <div *ngIf="
                    padPaymentControls['transit'].touched &&
                    padPaymentControls['transit'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['required']
                    ">{{lang.Please_enter_bank_transit}}</span>
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['minlength']
                    ">{{lang.Bank_transit_must_be_5_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['maxlength']
                    ">{{lang.Bank_transit_must_be_5_digits}}</span>
                </div>
              </div>
              <div class="form-group col-4">
                <label class="Corporation text-nowrap">{{lang.Account_No}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" formControlName="accountNumber"
                  placeholder={{lang.Account_No}} style="height: 30px" maxlength="12" (keypress)="numberOnly($event)" />
                <div *ngIf="
                    padPaymentControls['accountNumber'].touched &&
                    padPaymentControls['accountNumber'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['required']
                    ">{{lang.Please_enter_Account_number}}</span>
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['minlength']
                    ">{{lang.Account_number_minimum_of_5_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['maxlength']
                    ">{{lang.Account_number_maximum_of_12_digits}}</span>
                </div>
              </div>
              <div class="form-group col-12 mt-1">
                <label class="Corporation">{{lang.Bank_Details}}:</label>
                <textarea [ngModel]="bankDetailsNames" rows="6" class="mt-1 form-control no-drop border border-dark"
                  placeholder="{{lang.Bank_Details}}" id rows="5" formControlName
                  readonly>{{ bankDetailsNames }}</textarea>

                <div *ngIf="
                    this.padPaymentControls['bankCode']?.valid &&
                    this.padPaymentControls['transit']?.valid &&
                    this.padPaymentControls['accountNumber']?.valid
                  " class="form-group col-12 text-end">
                  <div class="signbtn mt-1">
                    <button class="btn btn-dark btn-inline personalinfobutton" (click)="verifybankdetails1()">
                      {{lang.Verify}}
                    </button>

                    <button class="ms-2 btn btn-dark btn-inline personalinfobutton" (click)="bankDetailsClear()">
                      {{lang.Clear}}
                    </button>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="isBankDetailsValid">
                <label for class="col-12">{{lang.Upload_Void_Cheque}} <span class="text-danger">*</span></label>
                <div class="col-9">
                  <input type="file" class="chooseFile" formControlName="padDetailsVoidUpload"
                    (change)="voidcheckupload($event)" />
                </div>
                <!-- below div for preview of void check -->
                <!-- <div class="col-3">
                      <div class=""
                        *ngIf="isBankDetailsValid && voidPreviewButtonVisible">
                        <button
                          class="btn btn-primary ftsize personalinfobutton"
                          data-bs-toggle="modal"
                          data-bs-target="#voidPreview-modal"
                          (click)="voidPdfEnable()">Preview</button>
                      </div>
                    </div> -->
              </div>
            </div>
          </form>
          <!-- credit card details -->
          <form [formGroup]="creditCardForm" #creditCardForm1 *ngIf="!paymentMethodSelect"
            action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
            <div class="row">
              <div class="form-group col-12">
                <label for="cardnumnber" class="Corporation">{{lang.Card_Number}}<span
                    style="color: red">*</span></label>

                <input class="form-control" id="CardNumber" placeholder={{lang.Card_Number}} name="CardNumber"
                  formControlName="CardNumber" (input)="creditcardlblurmethod($event)"
                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                <div *ngIf="
                    creditCardControls['CardNumber'].touched &&
                    creditCardControls['CardNumber'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['CardNumber'].errors &&
                      creditCardControls['CardNumber'].errors['required']
                    ">
                    {{lang.Please_enter_Card_number}}
                  </div>
                  <div *ngIf="
                      invalidcreditcard ||
                      (creditCardControls['CardNumber'].touched &&
                        creditCardControls['CardNumber'].hasError(
                          'invalidcreditcarddetails'
                        ))
                    ">
                    {{lang.Please_enter_valid_Card_number}}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label for="expirymonth" class="selectCorporation">{{lang.Expiry_Month}}<span
                    style="color: red">*</span></label>

                <select class="form-control" id="ExpirationMonth" name="ExpirationMonth"
                  formControlName="ExpirationMonth" (input)="changeexpirymonth($event)" placeholder="MM">
                  <option value disabled selected>{{lang.Select}}</option>
                  <option value="01">Jan</option>
                  <option value="02">Feb</option>
                  <option value="03">Mar</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">Aug</option>
                  <option value="09">Sept</option>
                  <option value="10">Oct</option>
                  <option value="11">Nov</option>
                  <option value="12">Dec</option>
                </select>

                <div *ngIf="
                    creditCardControls['ExpirationMonth'].touched &&
                    creditCardControls['ExpirationMonth'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['ExpirationMonth'].errors &&
                      creditCardControls['ExpirationMonth'].errors['required']
                    ">
                    {{lang.Please_select_expiry_month}}
                  </div>
                </div>
                <!-- <div *ngIf="showexpirymontherror"
                    class="help-block text-danger">Please enter valid Expiry
                    month</div> -->
                <!-- <div class="clearfix"></div> -->
              </div>

              <div class="form-group col-12 col-md-4">
                <label for="expiryyear" class="selectCorporation">{{lang.Expiry_Year}}<span
                    style="color: red">*</span></label>

                <select class="form-control" id="ExpirationYear" placeholder="YY" name="ExpirationYear"
                  formControlName="ExpirationYear" (input)="changeexpiryyear($event)">
                  <option value disabled selected>{{lang.Select}}</option>
                  <!-- <option value="23">2023</option> -->
                  <!-- <option value="24">2024</option> -->
                  <option value="25">2025</option>
                  <option value="26">2026</option>
                  <option value="27">2027</option>
                  <option value="28">2028</option>
                  <option value="29">2029</option>
                  <option value="30">2030</option>
                  <option value="31">2031</option>
                  <option value="32">2032</option>
                  <option value="33">2033</option>
                  <option value="34">2034</option>
                  <option value="35">2035</option>
                  <option value="36">2036</option>
                  <option value="37">2037</option>
                  <option value="38">2038</option>
                  <option value="39">2039</option>
                  <option value="40">2040</option>
                  <option value="41">2041</option>
                  <option value="42">2042</option>
                  <option value="43">2043</option>
                  <option value="44">2044</option>
                  <option value="45">2045</option>
                  <option value="46">2046</option>
                  <option value="47">2047</option>
                  <option value="48">2048</option>
                  <option value="49">2049</option>
                  <option value="50">2050</option>
                  <option value="51">2051</option>
                  <option value="52">2052</option>
                  <option value="53">2053</option>
                  <option value="54">2054</option>
                  <option value="55">2055</option>
                  <option value="56">2056</option>
                  <option value="57">2057</option>
                  <option value="58">2058</option>
                  <option value="59">2059</option>
                  <option value="60">2060</option>
                  <option value="61">2061</option>
                  <option value="62">2062</option>
                  <option value="63">2063</option>
                  <option value="64">2064</option>
                  <option value="65">2065</option>
                  <option value="66">2066</option>
                  <option value="67">2067</option>
                  <option value="68">2068</option>
                  <option value="69">2069</option>
                  <option value="70">2070</option>
                  <option value="71">2071</option>
                  <option value="72">2072</option>
                  <option value="73">2073</option>
                  <option value="74">2074</option>
                  <option value="75">2075</option>
                </select>
                <div *ngIf="
                    creditCardControls['ExpirationYear'].touched &&
                    creditCardControls['ExpirationYear'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['ExpirationYear'].errors &&
                      creditCardControls['ExpirationYear'].errors['required']
                    ">
                    {{lang.Please_select_expiry_year}}
                  </div>
                </div>
                <!-- <div *ngIf="showexpiryyearerror"
                    class="help-block text-danger">Please enter valid Expiry
                    year</div> -->
              </div>

              <div class="form-group col-12 col-md-4">
                <label for="cvv" class="Corporation">{{lang.CVV}}<span style="color: red">*</span></label>
                <input class="form-control" id="Cvv" placeholder={{lang.CVV}} name="Cvv" formControlName="cvv"
                  maxlength="4" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                <div *ngIf="
                    creditCardControls['cvv'].touched &&
                    creditCardControls['cvv'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['cvv'].errors &&
                      creditCardControls['cvv'].errors['required']
                    ">
                    {{lang.Please_enter_cvv}}
                  </div>
                  <div *ngIf="
                      creditCardControls['cvv'].errors &&
                      creditCardControls['cvv'].errors['minlength']
                    ">
                    {{lang.CVV_must_be_3_or_4_digits}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <re-captcha (resolved)="resolvedpayment($event)" formControlName="recaptchaReactivepayment"
                  siteKey="{{ fusbillinfocaptchavalue }}">
                </re-captcha>
                <div *ngIf="
                    creditCardControls['recaptchaReactivepayment'].touched &&
                    creditCardControls['recaptchaReactivepayment'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['recaptchaReactivepayment'].errors &&
                      creditCardControls['recaptchaReactivepayment'].errors[
                        'required'
                      ]
                    ">
                    {{lang.Please_select_recaptcha}}
                  </div>
                  <!-- <div *ngIf="credit['cvv'].errors && credit['cvv'].errors['minlength']">{{lang.CVV_must_be_3_or_4_digits}}</div> -->
                </div>

                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponsepayment" />
              </div>
            </div>
            <span class="row">
              <div class="form-group col-3">
                <input class="form-control" autofocus="autofocus" id="CustomerId" formcontrolname="cutomerId"
                  name="CustomerID" type="hidden" value="{{ customerid }}" />
              </div>
              <div class="form-group col-3">
                <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                  type="hidden" value="{{ publicapikey }}" />
              </div>
              <div class="form-group col-3">
                <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri" type="hidden"
                  value="{{ paymentsuccessuri }}" />
              </div>
              <div class="form-group col-3">
                <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                  value="{{ paymentUri }}" />
              </div>
            </span>

            <span class="row">
              <div class="form-group col-4">
                <input class="form-control" id="firstname" placeholder="First Name" name="FirstName" type="hidden"
                  value="{{ paymentfirstname }}" />
              </div>
              <div class="form-group col-4">
                <input class="form-control" id="LastName" placeholder="Last Name" name="LastName" type="hidden"
                  value="{{ paymentlastname }}" />
              </div>
              <div class="form-group col-4">
                <input class="form-control" id="Email" placeholder="Email" type="hidden" name="email"
                  value="{{ paymentemail }}" />
              </div>
            </span>

            <div class="modal-footer p-0 paymentMethodBtn" *ngIf="!paymentMethodSelect">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="paymentInfoCancel()">
                {{lang.Cancel}}
              </button>
              <button type="button" class="btn btn-primary"
                [disabled]="getPaymentMethodControls['creditCardForm'].invalid"
                (click)="creditcardpaysubmit1($event, creditCardForm1)">
                {{lang.Submit}}
              </button>
            </div>
          </form>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- payment info of pad -->
<div class="modal" id="paymentInformation-modal" role="dialog" aria-labelledby="modal-label"
  style="z-index: 1051 !important; display: none">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header p-2">
        <span class="modal-title col-11 text-center">Payment Information</span>
        <span class="col-1">
          <button type="button" class="btn-close ftsize12"
            data-bs-dismiss="modal"
            aria-label="Close" (click)="paymentInfoCancel()"></button>
        </span>
      </div> -->
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Payment_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="paymentInfoCancel()"></i>
        </div>
      </div>

      <div class="modal-body2 col-12" style="max-height: 350px">
        <form class="paymentMethodForm mt-2" [formGroup]="paymentMethodForm" (ngSubmit)="paymentMethodSubmit()">
          <form [formGroup]="padInformationForm" *ngIf="paymentMethodSelect">
            <div class="row mt-2">
              <div class="form-group col-4 mb-0">
                <label class="Corporation">{{lang.Bank_Code}}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="bank Code" formControlName="bankCode"
                  placeholder="Bank Code" maxlength="3" (keypress)="numberOnly($event)" />
                <div *ngIf="
                    padPaymentControls['bankCode'].touched &&
                    padPaymentControls['bankCode'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['required']
                    ">{{lang.Please_enter_bank_code}}</span>
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['minlength']
                    ">{{lang.Bank_code_must_be_3_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['bankCode'].errors &&
                      padPaymentControls['bankCode'].errors['maxlength']
                    ">{{lang.Bank_code_must_be_3_digits}}</span>
                </div>
              </div>

              <div class="form-group col-4 mb-0">
                <label class="Corporation">{{lang.Transit}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" formControlName="transit"
                  placeholder={{lang.Transit}} style="height: 30px" maxlength="5" (keypress)="numberOnly($event)" />

                <div *ngIf="
                    padPaymentControls['transit'].touched &&
                    padPaymentControls['transit'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['required']
                    ">{{lang.Please_enter_bank_transit}}</span>
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['minlength']
                    ">{{lang.Bank_transit_must_be_5_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['transit'].errors &&
                      padPaymentControls['transit'].errors['maxlength']
                    ">{{lang.Bank_transit_must_be_5_digits}}</span>
                </div>
              </div>
              <div class="form-group col-4 mb-0">
                <label class="Corporation text-nowrap">{{lang.Account_No}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" formControlName="accountNumber"
                  placeholder={{lang.Account_No}} style="height: 30px" maxlength="12" (keypress)="numberOnly($event)" />
                <div *ngIf="
                    padPaymentControls['accountNumber'].touched &&
                    padPaymentControls['accountNumber'].invalid
                  " class="help-block text-danger">
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['required']
                    ">{{lang.Please_enter_Account_number}}</span>
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['minlength']
                    ">{{lang.Account_number_minimum_of_5_digits}}</span>
                  <span *ngIf="
                      padPaymentControls['accountNumber'].errors &&
                      padPaymentControls['accountNumber'].errors['maxlength']
                    ">{{lang.Account_number_maximum_of_12_digits}}</span>
                </div>
              </div>
              <div *ngIf="
                  this.padPaymentControls['bankCode']?.valid &&
                  this.padPaymentControls['transit']?.valid &&
                  this.padPaymentControls['accountNumber']?.valid
                ">
                <div class="signbtn mt-1 d-flex flex-row-reverse">
                  <button class="btn btn-dark btn-inline personalinfobutton" (click)="verifybankdetails1()">
                    {{lang.Verify}}
                  </button>
                </div>
              </div>
              <div class="form-group col-12 mt-1" *ngIf="bankDetailsNames">
                <label class="Corporation">{{lang.Bank_Details}}:</label>
                <textarea [ngModel]="bankDetailsNames" rows="6" class="mt-1 form-control no-drop border border-dark"
                  placeholder="{{lang.Bank_Details}}" id rows="5" formControlName
                  readonly>{{ bankDetailsNames }}</textarea>

                <div *ngIf="
                    this.padPaymentControls['bankCode']?.valid &&
                    this.padPaymentControls['transit']?.valid &&
                    this.padPaymentControls['accountNumber']?.valid
                  " class="form-group col-12 text-end signbtn mt-1 d-flex flex-row-reverse p-0 mb-0">
                  <!-- <div class="signbtn mt-1"> -->
                  <!-- <button
                      class="btn btn-dark btn-inline personalinfobutton"
                      (click)="verifybankdetails1()">Verify</button> -->

                  <button class="btn btn-dark btn-inline personalinfobutton" (click)="bankDetailsClear()">
                    {{lang.Clear}}
                  </button>
                  <!-- </div> -->
                </div>
              </div>

              <div class="row" *ngIf="isBankDetailsValid">
                <label for class="col-12 mb-0">{{lang.Upload_Void_Cheque}} <span class="text-danger">*</span></label>
                <div class="col-9">
                  <input type="file" class="chooseFile" formControlName="padDetailsVoidUpload"
                    (change)="voidcheckupload($event)" />
                </div>
                <!-- below div for preview of void check -->
                <div class="col-3">
                  <div class *ngIf="isBankDetailsValid && voidPreviewButtonVisible">
                    <button class="btn btn-primary ftsize personalinfobutton" data-bs-toggle="modal"
                      data-bs-target="#voidPreview-modal" (click)="voidPdfEnable()">
                      {{lang.Preview}}
                    </button>
                  </div>
                </div>
              </div>
              <div class="mt-1" *ngIf="isBankDetailsValid">
                <!-- [ngClass]="{'padBtnClr':!reviewPadSign}" -->
                <button class="btn btn-primary p-1" style="float: left" (click)="showPad()" [disabled]="!reviewPadSign">
                  {{lang.Review_and_Sign_the_PAD_Agreement}}
                </button>
              </div>
              <div class="mb-5"></div>
            </div>
          </form>

          <form class [formGroup]="creditCardForm" #creditCardForm1 *ngIf="!paymentMethodSelect"
            action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
            <div class>
              <div class="form-group">
                <input class="form-control" autofocus="autofocus" id="CustomerId" formcontrolname="cutomerId"
                  name="CustomerID" type="hidden" value="{{ customerid }}" />
              </div>
              <div class="form-group">
                <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                  type="hidden" value="{{ publicapikey }}" />
              </div>
              <div class="form-group">
                <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri" type="hidden"
                  value="{{ paymentsuccessuri }}" />
              </div>
              <div class="form-group">
                <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                  value="{{ paymentUri }}" />
              </div>
            </div>

            <div class>
              <div class="form-group">
                <input class="form-control" id="firstname" placeholder="First Name" name="FirstName" type="hidden"
                  value="{{ paymentfirstname }}" />
              </div>
              <div class="form-group">
                <input class="form-control" id="LastName" placeholder="Last Name" name="LastName" type="hidden"
                  value="{{ paymentlastname }}" />
              </div>
              <div class="form-group">
                <input class="form-control" id="Email" placeholder="Email" type="hidden" name="email"
                  value="{{ paymentemail }}" />
              </div>
            </div>

            <div class="row mt-2">
              <div class="form-group col-12">
                <label for="cardnumnber" class="Corporation">{{lang.Card_Number}}<span
                    style="color: red">*</span></label>

                <input class="form-control" id="CardNumber" placeholder={{lang.Card_Number}} name="CardNumber"
                  formControlName="CardNumber" (input)="creditcardlblurmethod($event)"
                  (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                <div *ngIf="
                    creditCardControls['CardNumber'].touched &&
                    creditCardControls['CardNumber'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['CardNumber'].errors &&
                      creditCardControls['CardNumber'].errors['required']
                    ">
                    {{lang.Please_enter_Card_number}}
                  </div>
                  <div *ngIf="
                      invalidcreditcard ||
                      (creditCardControls['CardNumber'].touched &&
                        creditCardControls['CardNumber'].hasError(
                          'invalidcreditcarddetails'
                        ))
                    ">
                    {{lang.Please_enter_valid_Card_number}}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md-4">
                <label for="expirymonth" class="selectCorporation">{{lang.Expiry_Month}}<span
                    style="color: red">*</span></label>

                <select class="form-control" id="ExpirationMonth" name="ExpirationMonth"
                  formControlName="ExpirationMonth" (input)="changeexpirymonth($event)"
                  placeholder={{lang.Expiry_Month}}>
                  <option value disabled selected>{{lang.Select}}</option>
                  <option value="01">Jan</option>
                  <option value="02">Feb</option>
                  <option value="03">Mar</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">Aug</option>
                  <option value="09">Sept</option>
                  <option value="10">Oct</option>
                  <option value="11">Nov</option>
                  <option value="12">Dec</option>
                </select>

                <div *ngIf="
                    creditCardControls['ExpirationMonth'].touched &&
                    creditCardControls['ExpirationMonth'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['ExpirationMonth'].errors &&
                      creditCardControls['ExpirationMonth'].errors['required']
                    ">
                    {{lang.Please_select_expiry_month}}
                  </div>
                </div>
              </div>

              <div class="form-group col-12 col-md-4">
                <label for="expiryyear" class="selectCorporation">{{lang.Expiry_Year}}<span
                    style="color: red">*</span></label>

                <select class="form-control" id="ExpirationYear" placeholder="YY" name="ExpirationYear"
                  formControlName="ExpirationYear" (input)="changeexpiryyear($event)">
                  <option value disabled selected>{{lang.Select}}</option>
                  <!-- <option value="23">2023</option>
                  <option value="24">2024</option> -->
                  <option value="25">2025</option>
                  <option value="26">2026</option>
                  <option value="27">2027</option>
                  <option value="28">2028</option>
                  <option value="29">2029</option>
                  <option value="30">2030</option>
                  <option value="31">2031</option>
                  <option value="32">2032</option>
                  <option value="33">2033</option>
                  <option value="34">2034</option>
                  <option value="35">2035</option>
                  <option value="36">2036</option>
                  <option value="37">2037</option>
                  <option value="38">2038</option>
                  <option value="39">2039</option>
                  <option value="40">2040</option>
                  <option value="41">2041</option>
                  <option value="42">2042</option>
                  <option value="43">2043</option>
                  <option value="44">2044</option>
                  <option value="45">2045</option>
                  <option value="46">2046</option>
                  <option value="47">2047</option>
                  <option value="48">2048</option>
                  <option value="49">2049</option>
                  <option value="50">2050</option>
                  <option value="51">2051</option>
                  <option value="52">2052</option>
                  <option value="53">2053</option>
                  <option value="54">2054</option>
                  <option value="55">2055</option>
                  <option value="56">2056</option>
                  <option value="57">2057</option>
                  <option value="58">2058</option>
                  <option value="59">2059</option>
                  <option value="60">2060</option>
                  <option value="61">2061</option>
                  <option value="62">2062</option>
                  <option value="63">2063</option>
                  <option value="64">2064</option>
                  <option value="65">2065</option>
                  <option value="66">2066</option>
                  <option value="67">2067</option>
                  <option value="68">2068</option>
                  <option value="69">2069</option>
                  <option value="70">2070</option>
                  <option value="71">2071</option>
                  <option value="72">2072</option>
                  <option value="73">2073</option>
                  <option value="74">2074</option>
                  <option value="75">2075</option>
                </select>
                <div *ngIf="
                    creditCardControls['ExpirationYear'].touched &&
                    creditCardControls['ExpirationYear'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['ExpirationYear'].errors &&
                      creditCardControls['ExpirationYear'].errors['required']
                    ">
                    {{lang.Please_select_expiry_year}}
                  </div>
                </div>
              </div>

              <div class="form-group col-12 col-md-4">
                <label for="cvv" class="Corporation">{{lang.CVV}}<span style="color: red">*</span></label>
                <input class="form-control" id="Cvv" placeholder={{lang.CVV}} name="Cvv" formControlName="cvv"
                  maxlength="4" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                <div *ngIf="
                    creditCardControls['cvv'].touched &&
                    creditCardControls['cvv'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['cvv'].errors &&
                      creditCardControls['cvv'].errors['required']
                    ">
                    {{lang.Please_enter_cvv}}
                  </div>
                  <div *ngIf="
                      creditCardControls['cvv'].errors &&
                      creditCardControls['cvv'].errors['minlength']
                    ">
                    {{lang.CVV_must_be_3_or_4_digits}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <re-captcha (resolved)="resolvedpayment($event)" formControlName="recaptchaReactivepayment"
                  siteKey="{{ fusbillinfocaptchavalue }}">
                </re-captcha>
                <div *ngIf="
                    creditCardControls['recaptchaReactivepayment'].touched &&
                    creditCardControls['recaptchaReactivepayment'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      creditCardControls['recaptchaReactivepayment'].errors &&
                      creditCardControls['recaptchaReactivepayment'].errors[
                        'required'
                      ]
                    ">
                    {{lang.Please_select_recaptcha}}
                  </div>
                </div>

                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponsepayment" />
              </div>
            </div>
            <div class="modal-footer" *ngIf="!paymentMethodSelect">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton"
                (click)="paymentInfoCancel()">
                {{lang.Cancel}}
              </button>
              <button type="button" class="btn btn-primary" id="submitButton"
                [disabled]="getPaymentMethodControls['creditCardForm'].invalid"
                (click)="creditcardpaysubmit1($event, creditCardForm1)">
                {{lang.Submit}}
              </button>
            </div>
          </form>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Void check preview -->
<div id="voidPreview-modal" class="modal fade" data-bs-backdrop="static" style="height: 86%; margin-top: 4%">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="col-11 text-center">
          <span class="modal-title">{{lang.Preview}}</span>
        </div>
        <div class="col-1 text-end">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" data-bs-toggle="modal">
          </i>
        </div>
      </div>
      <div class="modal-body">
        <div *ngIf="
            voidCheckFileType == 'image/jpeg' ||
            voidCheckFileType == 'image/png'
          ">
          <img [src]="imagedisplayvoid" width="100%;" style="height: '400px'; zoom: 0.7" />
        </div>
        <!-- <div *ngIf="voidCheckFileType=='application/pdf'"> -->
        <pdf-viewer id="voidModalPdf" *ngIf="voidCheckFileType == 'application/pdf'" [src]="imagedisplayvoid"
          style="height: '400px'; zoom: 0.7"></pdf-viewer>
        <!-- </div> -->
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-primary ftsize" data-bs-dismiss="modal" data-bs-toggle="modal"
          id="cancelButton">
          <b>{{lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <app-header (GetCorpDetails)="getDetails()"></app-header> -->
<!-- Corporate info Modal popup start  -->
<div id="updateCorpInfo" class="modal fade" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Update_Corporate_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2" style="padding-right: 10px">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <form class [formGroup]="clientregform">
              <div class="input-wrapper row">
                <div class="form-group col-12 col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Name_of_Corporation}}<span
                      style="color: red">*</span></label>
                  <!-- [(ngModel)]="CorpName" -->
                  <input type="text" class="form-control checking-field" id="nameofcorporation"
                    placeholder="{{lang.Name_of_Corporation}}" formControlName="corporationName" [value]="CorpName" />
                  <!-- (blur)="checkNameExists()" /> -->
                  <div *ngIf="
                      client['corporationName'].touched &&
                      client['corporationName'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['required']
                      ">
                      {{lang.Please_enter_corporation_name}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['minlength']
                      ">
                      {{lang.Corporation_name_should_be_3_characters}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['maxlength']
                      ">
                      {{lang.Corporation_name_must_not_exceed_70_characters}}
                    </div>
                    <div *ngIf="
                        client['corporationName'].errors &&
                        client['corporationName'].errors['pattern']
                      ">
                      Corporation name Shouldn't allow numbers, special
                      characters and blank spaces
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Policy_Start_Date}}<span
                      style="color: red">*</span></label>

                  <select class="form-control ftsize" id="planenrollmentdate" placeholder=""
                    formControlName="PolicyStartDate" [(ngModel)]="policyStartDate">
                    <option value label>{{lang.Select}}</option>
                    <option *ngFor="let name of enrollmentDates" [value]="name" [label]="name">
                      {{ name }}
                    </option>
                  </select>
                  <div *ngIf="
                      client['PolicyStartDate'].touched &&
                      client['PolicyStartDate'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['PolicyStartDate'].errors &&
                        client['PolicyStartDate'].errors['required']
                      ">
                      {{lang.Please_choose_policy_start_date}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="multiSelectProviance" class="Corporation">{{lang.Provincial_offices_in_Operation}}<span
                      style="color: red">*</span></label>
                  <div class style="margin-top: -5px">
                    <ng-multiselect-dropdown class="ftsize" formControlName="multiSelectProviance"
                      placeholder={{lang.Select}} [settings]="dropdownSettings" [data]="configprovincereslist1"
                      (onSelect)="multiSelectProvianceItemSelect($event)"
                      (onSelectAll)="multiSelectProvianceSelectAll($event)"
                      (onDeSelect)="multiSelectProvianceItemDeSelect($event)" (onDeSelectAll)="
                        multiSelectProvianceItemDeSelectAll($event)
                      " style="background-color: rgb(232, 234, 240)">
                    </ng-multiselect-dropdown>
                  </div>
                  <div *ngIf="client['multiSelectProviance'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['multiSelectProviance'].errors &&
                        client['multiSelectProviance'].errors['required']
                      ">
                      {{lang.Please_select_province}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12 col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span
                      style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="Street Address"
                    placeholder={{lang.Street_Address}} style="text-transform: capitalize"
                    formControlName="streetAddress" [(ngModel)]="streetAddress" />
                  <div *ngIf="
                      client['streetAddress'].touched &&
                      client['streetAddress'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['streetAddress'].errors &&
                        client['streetAddress'].errors['required']
                      ">
                      {{lang.Please_enter_street_address_name}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                  <input type="text" class="form-control checking-field" style="text-transform: capitalize"
                    id="StreetAddreess2" placeholder={{lang.Street_Address_Line_2}} [(ngModel)]="streetAddress2"
                    formControlName="streetAddress2" />
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Unit_Apt_Suite}} #</label>

                  <input type="text" class="form-control checking-field" style="text-transform: capitalize" id="apt"
                    placeholder={{lang.Unit_Apt_Suite}} [(ngModel)]="apt" formControlName="apt" />
                  <div *ngIf="client['apt'].touched && client['apt'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        client['apt'].errors &&
                        client['apt'].errors['aptexpression']
                      ">
                      Please enter valid Unit/Apt/Suite number
                    </div>
                    <div *ngIf="
                        client['apt'].errors &&
                        client['apt'].errors['maxlength']
                      ">
                      Unit/Apt/Suite name must not exceed 10 characters
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                    style="text-transform: capitalize" formControlName="city" [(ngModel)]="city" />
                  <div *ngIf="client['city'].touched && client['city'].invalid" class="help-block text-danger">
                    <div *ngIf="
                        client['city'].errors &&
                        client['city'].errors['required']
                      ">
                      {{lang.Please_enter_city_name}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                  <select class="form-control" id="country" placeholder="" formControlName="country"
                    [(ngModel)]="country" (change)="getprovincelist($event)">
                    <option value [disabled]="true">{{lang.Select}}</option>
                    <option *ngFor="let country of countryList" [value]="country.name">
                      {{ country.name }}
                    </option>
                  </select>
                  <div *ngIf="
                      client['country'].touched && client['country'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['country'].errors &&
                        client['country'].errors['required']
                      ">
                      {{lang.Please_select_country}}
                    </div>
                  </div>
                </div>

                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{ stateLabel }}<span style="color: red">*</span></label>
                  <select class="form-control" id="Province" placeholder="Province" style="text-transform: capitalize"
                    formControlName="Province" (change)="provincelist($event.target.value)" [(ngModel)]="province">
                    <option value>{{lang.Select}}</option>

                    <option *ngFor="let name of configprovincereslist" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="
                      client['Province'].touched && client['Province'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        client['Province'].errors &&
                        client['Province'].errors['required']
                      ">
                      Please select province
                    </div>
                  </div>
                </div>
                <div class="form-group col-12 col-md-3">
                  <label for="Corporation" class="Corporation">{{ zipCodeLabel }}<span
                      style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="postalcode"
                    placeholder="{{ zipCodeLabel }}" onkeyup="this.value = this.value.toUpperCase();"
                    formControlName="postalCode" [(ngModel)]="postalCode"
                    (input)="changeTextToUppercase('postalcode', $event)" />
                  <div *ngIf="client['postalCode'].touched" class="help-block text-danger">
                    <div *ngIf="
                        client['postalCode'].errors &&
                        client['postalCode'].errors['required']
                      ">
                      Please enter
                      {{ zipCodeLabel }}
                    </div>
                    <div *ngIf="
                        invalidpostalcodeprivince ||
                        (client['postalCode'].touched &&
                          client['postalCode'].hasError('invalidPostalCode'))
                      ">
                      Please enter valid {{ zipCodeLabel }}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
          {{lang.Close}}
        </button>

        <button type="submit" class="btn btn-primary" id="submitButton" [disabled]="
            clientregform.invalid ||
            clientregform.get('postalCode').hasError('invalidPostalCode')
          " (click)="updateCorporateInformation()">
          {{lang.Update}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="deltebulkemployee-modal" role="dialog" aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style>
    <div class="modal-content" style="margin-top: 9%">
      <!-- <div class="modal-header">
        {{lang.Employee_Delete}}
      </div> -->
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Employee_Delete}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2" (click)="closedeleteemployee()">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <table class="table text-nowrap ft14" style="white-space: nowrap">
          <thead>
            <tr>
              <th style="margin-left: 20px"></th>
              <!-- <th style="width: 30px; padding-right: 8px">S.No</th> -->
              <th>{{lang.Employee_ID}}</th>
              <th>{{lang.First_Name}}</th>
              <th>{{lang.Last_Name}}</th>
              <th>{{lang.Email}}</th>
            </tr>
          </thead>
          <tbody style="border-top: 1px">
            <tr *ngFor="let admin of deleteBulkemployeelist; let i = index">
              <td style="padding-left: 10px">
                <input type="checkbox" (change)="toggleCheckbox($event, i, admin)" />
              </td>
              <!-- <td style="width: 20px">{{ i + 1 }}</td> -->
              <td style="text-transform: capitalize">{{ admin.employeeId }}</td>

              <td>{{ admin.firstName | capitalizeEachCharofWord }}</td>
              <td>{{ admin.lastName | capitalizeEachCharofWord }}</td>
              <td>{{ admin.email }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button id="closeButton" type="button" style="color: #0d0d0d" class="btn btn-sm btn-light ftsize14"
          data-bs-dismiss="modal" (click)="closedeleteemployee()">
          {{lang.Close}}
        </button>

        <button class="btn btn-primary" id="submitButton" (click)="confirmSubmitDeleteEmployee()">
          {{lang.Delete}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="deltebulkemployeeexcel-modal" role="dialog" aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="width: 40%">
    <div class="modal-content" style="margin-top: 9%">
      <div class="modal-header" style="height: 40px">{{lang.Info}}</div>
      <div class="modal-body">
        <div *ngIf="viweUploadButtons == true">
          <div style="margin-top: -15px; margin-bottom: 10px">
            {{lang.Upload_Employee_List}}
          </div>
          <span class="text-left" style="margin-left: 5px; margin-top: 3px">
            <label for="DownloadButton" id="uploadButtonExcel1" title="Download Template" data-taggle="tooltip"
              (click)="exportAsXLSXBulkPlans()" class="cursor-pointer">
              <!-- <i class="fa fa-download"></i> -->
              <img class="imgSize50" src="./../assets/img/download-template-V3.png" alt /> </label></span>
          <span style="margin-left: 5px; margin-top: 3px">
            <label for="uploadButton" id="uploadButtonExcel1" title="Upload Employee/Entity List" data-taggle="tooltip"
              class="cursor-pointer ms-2">
              <!-- <i class="fa fa-upload"></i> -->
              <img class="imgSize50" src="./../assets/img/upload-employee-list-V3.png" alt />
              <input id="uploadButton" #myFileInput style="display: none" type="file"
                (input)="onFileChangeExcelBulk($event)" />
            </label>
            &nbsp;&nbsp;
          </span>
        </div>
        <div *ngIf="viweUploadButtons == false" id="showFileName">
          <div style="display: flex; gap: 10px; cursor: pointer">
            <div>{{ fileName }}</div>
            <div id="viewDataTable" (click)="showUploadedData()">
              <i class="bi bi-eye-fill"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button id="closeButton" type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
          (click)="closedeleteemployee()">
          {{lang.Close}}
        </button>

        <button class="btn btn-primary" id="submitButton" (click)="submituploademployeeData()">
          {{lang.Upload}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Confirm Modal -->
<div class="modal" id="confirm-modal" role="dialog" aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="width: 40%">
    <div class="modal-content" style="margin-top: 9%">
      <div class="modal-header" style="height: 30px">{{lang.Info}}</div>

      <div class="modal-body">
        <div style="margin-top: -15px; margin-bottom: 10px; font-size: 16px">
          {{lang.Are_you_sure_you_want_to_delete}}
        </div>
      </div>
      <div class="modal-footer">
        <button id="closeButton" type="button" class="btn btn-sm btn-light ftsize14" data-bs-dismiss="modal"
          (click)="closeConfirmSubmitDeleteEmployee()">
          {{lang.Close}}
        </button>

        <button class="btn btn-primary" id="submitButton" (click)="submitdeleteemployee()">
          {{lang.Delete}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Invoice Modal -->
<div id="invoice-modal" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <!-- <div class="modal-header justify-content-between" >
        <h6 class="modal-title">Invosice</h6>
        <i  class="bi bi-x-circle" role="button" aria-hidden="true"
          data-bs-dismiss="modal"></i>
      </div> -->
      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Invoice}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <!-- <div> -->

        <pdf-viewer *ngIf="true" id="pdf-viewer" [src]="selectedInvoiceUrl" [render-text]="true"
          [original-size]="false"></pdf-viewer>

        <!-- </div> -->
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- without signed pad -->
<div class="modal fade viewModal" id="PADpafaggrement1-modal" data-bs-backdrop="static" aria-labelledby="modal-label"
  style="display: none" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.PAD_Agreement}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" id="modal-body1">
        <pdf-viewer id="pdf-viewer" *ngIf="true" [src]="generatePADaggrement" class="providersSize"
          style="position: unset" class="withoutSignPadPdf"></pdf-viewer>
      </div>
      <div class="modal-footer py-2">
        <button class="btn btn-primary ftsize14" style="border-radius: 5px" (click)="signaturestartmodel()">
          <strong style="color: white">{{lang.Sign_Agree}}</strong>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Pad signature pad -->
<div class="modal viewModal" id="drawsignaturemodel-modal" aria-labelledby="modal-label" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <span class="modal-title col-12 text-center">Signature</span>
      </div> -->

      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Signature}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closePadSignModal()"></i>
        </div>
      </div>

      <div class="modal-body" style="max-width: 800px; max-height: 500px; overflow-y: hidden">
        <canvas #canvas (touchstart)="startDrawing($event)" (touchmove)="moved($event)" (touchend)="padSignEnd($event)"
          (click)="signaturestart($event)" required></canvas>
        <div *ngIf="signaturecheckvalue1" style="
            position: absolute;
            top: 25px;
            left: 104px;
            color: red;
            text-decoration: underline;
            cursor: pointer;
          ">
          <p (click)="clearPad()" style="margin-top: 5px !important">x Clear</p>
        </div>
      </div>

      <div class="modal-footer">
        <form class="signbtn" style="font-weight: 600">
          <button class="btn btn-primary btn-inline ms-1" [disabled]="!signaturecheckvalue1"
            (click)="savePadsignature()">
            {{lang.Confirm}}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- with signed Pad -->
<div class="modal fade viewModal" id="PADpafaggrement2-modal" data-bs-backdrop="static" aria-labelledby="modal-label"
  style="display: none" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.PAD_Agreement}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="rejectPADpafaggrement2()"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <pdf-viewer id="pdf-viewer" *ngIf="true" [src]="generatePADaggrement" class="providersSize"
          style="position: unset" class="withoutSignPadPdf"></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary ftsize14" style="border-radius: 5px" (click)="rejectPADpafaggrement2()">
          <strong style="color: white">{{lang.Close}}</strong>
        </button>
        <button class="btn btn-primary ftsize14" style="border-radius: 5px" (click)="DownloadContractPAD()">
          <strong style="color: white">{{lang.Download}}</strong>
        </button>
      </div>
    </div>
  </div>
</div>

<!--  PAD Modal -->
<div id="padModal" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.PAD_Agreement}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" id="modal-body1">
        <div>
          <pdf-viewer *ngIf="padUrl" id="pdf-viewer" [src]="padUrl" [render-text]="true"
            [original-size]="false" style="position: unset"></pdf-viewer>
        </div>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<!--  ROE Modal -->
<div id="roeModal" class="modal fade viewModal modal-dialog-scrollable" role="dialog" aria-labelledby="modal-label" style="display: none"
  data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Record_of_Enrollment}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" style="padding-right:18px;"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1" >
        <div *ngIf="isPdfLoading" class="text-center my-3">
    <div class="spinner-border text-primary" role="status"></div>
     <span class="visually-hidden">Loading...</span>
   
  </div>
   <div class="mt-2"></div>
        <div>
          <pdf-viewer *ngIf="roeUrl" id="pdf-viewer" [src]="roeUrl" [render-text]="true"
           style="display: block; width: 100%; height: 600px;"
            [original-size]="false"
             (after-load-complete)="onPdfLoadComplete()"></pdf-viewer>
            
        </div>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
          {{ lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->


<!-- Coporate info Modal Popup End -->
<div class="modal viewModal" id="bookletView-modal" role="dialog" aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.View_Plan_Booklets}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <!-- <div class="row" style="overflow-x: none;"> -->
        <!-- <div class="row" style="overflow-x: none;"> -->
        <pdf-viewer *ngIf="true" [src]="bookletUrlLink" id="pdf-viewer" style="position: unset"
          class="withoutSignPadPdf providersSize"></pdf-viewer>

        <!-- </div> -->
        <!-- </div> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
          {{lang.Close}}
        </button>

        <!-- <button class="btn btn-primary"
          style="border-radius:5px"
          (click)="signaturestartmodel()">
          <strong style="color: white">Sign & Agree</strong>
        </button> -->
      </div>
    </div>
  </div>
</div>

<div id="viewBooklet-modal" class="modal fade viewModal" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="modal-label" style="display: none">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Membership_Card}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="model-body1">
        <!-- <div> -->
        <pdf-viewer *ngIf="!isMembercardsavail" [src]="memberhealthCardurl" id="pdf-viewer" style="position: unset"
          class="providersSize"></pdf-viewer>
        <!-- </div> -->
        <span *ngIf="isMembercardsavail">
          {{ membershipcardsNodataFound }}
        </span>
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="cancelButton">
          <b>{{ lang.Close}}</b>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Draft Invoices modal -->
<div id="draftInvoice-modal" class="modal fade viewModal2" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" id="heightWidthModal2">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Invoice}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body">
        <!-- <div> -->
        <div [innerHTML]="draftInvoice" class="providersSize"></div>
        <!-- </div> -->
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="closeButton">
          {{ lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal modal-md fade"
  id="emailConfirmationModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="col-11 text-white text-center">{{lang?.Info}}</div>
        <i
          class="bi bi-x-circle text-light"
          style="cursor: pointer"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        {{ lang?.Send_a_link_to_update_payment_details_for }}
        <b>{{ groupContacts[0]?.firstName | titlecase }} {{ groupContacts[0]?.lastName | titlecase }}</b>
        <!-- <div>
          <input role="checkbox"/>
          {{ groupContacts[0]?.firstName | titlecase }} {{ groupContacts[0]?.lastName | titlecase }}
        </div> -->

        <div class="d-flex gap-1 row" *ngFor="let checkbox of inviteEmails ;  let i = index">
          <div class="col-12 d-flex gap-1">
              <input type="checkbox" [(ngModel)]="checkbox.checked" />
              <span>{{ checkbox.label }}</span>
          </div>
        </div>

        <div class="col-12 gap-1">
          <!-- Form Control Binding -->
          <form [formGroup]="emailForm" style="align-items: baseline;" class="d-flex" (ngSubmit)="addEmail()">
            <div class="w-100">
              <input
              class="form-control"
              type="text"
              id="email"
              formControlName="newEmail"
              placeholder="Enter email" />
            <!-- Validation Errors -->
            <div *ngIf="emailForm.controls['newEmail'].invalid && emailForm.controls['newEmail'].touched">
              <small *ngIf="emailForm.controls['newEmail'].hasError('pattern')" class="text-danger">
                Please enter a valid email address.
              </small>
            </div>
          </div>
            <!-- Add button -->
            <button
              type="submit"
              class="btn confirm text-nowrap"
              style="margin-left:5px;"
              [disabled]="emailForm.invalid || emailForm.get('newEmail')?.value ==''">
                Add Email
              </button>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cancel-button"
          data-bs-dismiss="modal"
        >
          {{lang?.Close}}
        </button>
        <button
          type="button"
          class="btn confirm"
          [disabled]="getSelectedEmails().length==0"
          (click)="paymentUpdationInvitationMail()"
        >
          {{lang?.Confirm}}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal modal-md fade"
  id="editEmailConfiguration"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="col-11 text-white text-center">Invoice: Edit email preference</div>
        <i
          class="bi bi-x-circle text-light"
          style="cursor: pointer"
          role="button"
          aria-hidden="true"
          data-bs-dismiss="modal"
        ></i>
      </div>
      <div class="modal-body">
        Email Invoice to:
        <div class="d-flex gap-1 row" *ngFor="let checkbox of configurationEmails ;  let i = index">
          <div class="col-12 d-flex gap-1">
              <input type="checkbox" [(ngModel)]="checkbox.checked" />
              <span>{{ checkbox.label }}</span>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cancel-button"
          data-bs-dismiss="modal"
        >
          {{lang?.Close}}
        </button>
        <button
          type="button"
          class="btn confirm"
          [disabled]="getSelectedEmails().length==0"
          (click)="paymentUpdationInvitationMail()"
        >
          {{lang?.Confirm}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- *******************************End Corp info -->
